
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams, useNavigate, json } from 'react-router-dom';
// ... other imports
import './styles/style.css';
// import Config from './Config';
import Svg from '../../../common/Svg';
import { Link } from 'react-router-dom';
import { FieldLabel, DropZone } from "@measured/puck";
import ReactEcharts from "echarts-for-react";
import Range from "./Range";
import { Render } from '@measured/puck';
import { ToastContainer, toast } from 'react-toastify';
import { resolveMediaUrl, resolveMediaCssUrl } from '../../../common/mediaUrl';

const ROIPage = () => {
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;
    const { roiId } = useParams();
    const [isIdPresent, setIsIdPresent] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [renderData, setRenderData] = useState(null);
    const [renderModalData, setRenderModalData] = useState(null);
    const [roiPageData, setRoiPageData] = useState(null);
    const [condtionValues, setCondtionValues] = useState([]);
    const [actionId, setActionId] = useState([]);
    //all condtions and actions data
    const [allCondtionalLogicData, setAllConditionalLogicData] = useState([]);
    const [allActionData, setAllActionData] = useState([])
    const [currentPageId, setCurrentPageId] = useState(null);
    const [currentPopupPageId, setCurrentPopupPageId] = useState(null);
    const [popupStatus, setPopupStatus] = useState(false);
    const [roipages, setRoipages] = useState({});
    const [roiVariableData, setRoiVaiableData] = useState({});
    const [roiActionArr, setRoiActionArr] = useState({});
    const [roiFlag, setRoiFlag] = useState(false);
    const [language, setLanguage] = useState('');
    const [currency, setCurrency] = useState([]);
    const [defaultCurrency, setDefaultCurrency] = useState('');
    const [changedCurrency, setChangedCurrency] = useState('');
    const [currencySymbol, setCurrencySymbol] = useState('');
    const [exchangeRate, setExchangeRate] = useState('');
    const [locale, setLocale] = useState('');
    const [globalRoiArr, setGlobalRoiArr] = useState([]);
    const [changedDropdown, setChangedDropdown] = useState([]);


    const CurrencyFormatter = ({ amount }) => {
        const formattedAmount = amount.toLocaleString(locale, {
            style: 'currency',
            currency: changedCurrency == '' ? defaultCurrency : changedCurrency,
        });
        //console.log("formattedAmount",formattedAmount)
        return formattedAmount;
    };

    /*****Year and VBUC******/
    const [selectedCompany, setSelectedCompany] = useState('microsoft');
    const [selectedYear, setSelectedYear] = useState('year1');

    const handleCompanyChange = (e) => {
        setSelectedCompany(e.target.value);
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    // const getDataSection = () => {
    //     if (selectedCompany === 'vbuc' && selectedYear === 'year1') {
    //         return <ReactEcharts style={chartStyle} option={pieChart()} />;
    //     }
    //     if (selectedCompany === 'vbuc' && selectedYear === 'year3') {
    //         return <ReactEcharts style={chartStyle} option={VBUCYear3Options} />;
    //     }
    //     if (selectedCompany === 'microsoft' && selectedYear === 'year1') {
    //         return <ReactEcharts style={chartStyle} option={MicrosoftYear1Options} />;
    //     }
    //     if (selectedCompany === 'microsoft' && selectedYear === 'year3') {
    //         return <ReactEcharts style={chartStyle} option={MicrosoftYear3Options} />;
    //     }
    // };


    const pieChart = (items) => {

        //console.log('items chart', items);

        // Transform items to match the required series data format
        const seriesData = items.map(item => ({
            value: parseFloat(item.value), // Convert value to a number if it's a string
            name: item.Text,
            symbol: currencySymbol,
            formatted: CurrencyFormatter({ amount: parseFloat(item.value) }),
        }));

        // Extract colors from items
        const colors = items.map(item => item.Color);

        return {
            tooltip: {
                trigger: 'item',

                formatter: function (params) {
                    // console.log('params', params);
                    return `${params.seriesName}<br />
                        ${params.data.name}:  ${params.data.formatted} `;
                }
            },
            grid: {
                left: '30%',
                right: '4%',
                bottom: '10%',
                containLabel: true
            },
            series: [
                {
                    name: 'Cost savings over yearly vs average',
                    type: 'pie',
                    radius: '80%',
                    color: colors, // Use the extracted colors
                    data: seriesData,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }
    };


    // For Download Report

    const OneYearChartOptions = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            left: 'left'
        },
        grid: {
            left: '30%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        series: [
            {
                name: 'Actual Benefits with Vodafone',
                type: 'pie',
                radius: '50%',
                color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Specify colors for the pie slices here
                data: [
                    { value: 1048, name: 'Lower Costs' },
                    { value: 735, name: 'Increase Productivity' },
                    { value: 580, name: 'Enable Business' },

                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };

    const ThreeYearChartOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            orient: 'vertical',
            left: 'left'
        },
        grid: {
            left: '0%',
            top: '30%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: ['2022', '2023', '2024']
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: [

            {
                name: 'Lower Costs',
                type: 'bar',
                stack: 'Ad',
                barWidth: '60',
                emphasis: {
                    focus: 'series'
                },
                itemStyle: {
                    color: '#9C2AA0' // Apply purple color here
                },
                data: [120, 132, 101, 134, 90, 230, 210]
            },
            {
                name: 'Increase Productivity',
                type: 'bar',
                stack: 'Ad',
                barWidth: '60',
                emphasis: {
                    focus: 'series'
                },
                itemStyle: {
                    color: '#EB9700' // Apply orange color here
                },
                data: [220, 182, 191, 234, 290, 330, 310]
            },
            {
                name: 'Enable Business',
                type: 'bar',
                stack: 'Ad',
                barWidth: '60',
                emphasis: {
                    focus: 'series'
                },
                itemStyle: {
                    color: '#00B0CA' // Apply cyan color here
                },
                data: [150, 232, 201, 154, 190, 330, 410]
            },
        ]
    };

    const chartStyle = {
        height: '200px',
        width: '100%',
    }

    const PieChartOptions = {
        tooltip: {
            trigger: 'item'
        },

        grid: {
            left: '30%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        series: [
            {
                // name: 'Actual Benefits with Vodafone',
                type: 'pie',
                radius: '50%',
                color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Specify colors for the pie slices here
                data: [
                    { value: 1048, name: 'Lower Costs' },
                    { value: 735, name: 'Increase Productivity' },
                    { value: 580, name: 'Enable Business' },

                ],
                top: "0%",
                radius: ["0%", "100%"],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };

    const BarChartOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },

        grid: {
            left: '0%',
            top: '5%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: ['2022', '2023', '2024']
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: [

            {
                name: 'Lower Costs',
                type: 'bar',
                stack: 'Ad',
                barWidth: '60',
                emphasis: {
                    focus: 'series'
                },
                itemStyle: {
                    color: '#9C2AA0' // Apply purple color here
                },
                data: [120, 132, 101, 134, 90, 230, 210]
            },
            {
                name: 'Increase Productivity',
                type: 'bar',
                stack: 'Ad',
                barWidth: '60',
                emphasis: {
                    focus: 'series'
                },
                itemStyle: {
                    color: '#EB9700' // Apply orange color here
                },
                data: [220, 182, 191, 234, 290, 330, 310]
            },
            {
                name: 'Enable Business',
                type: 'bar',
                stack: 'Ad',
                barWidth: '60',
                emphasis: {
                    focus: 'series'
                },
                itemStyle: {
                    color: '#00B0CA' // Apply cyan color here
                },
                data: [150, 232, 201, 154, 190, 330, 410]
            },
        ]
    };

    // Create Puck component config
    const config = {
        categories: {
            Banner: {
                components: ["BannerLeftTextRightImage", "BannerCenterText"],
            },

            Cards: {
                components: ["CardLayout1", "CardLayout2"],
            },

        },

        components: {

            //Header Components
            PageHeader: {


                render: ({ logo, items, hide, showCurrencyDropdown, showLanguageDropdown, transparentHeader }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <div className={`roi-header-main ${transparentHeader && 'header-transparent'}`} style={{ opacity: inputOpacity }}>
                            <div className="container">
                                <div className="header-wrapper">
                                    {/* <a href="" className="logo">
                                        <img src={resolveMediaUrl(logo)} alt="" onClick={homeRedirect} />
                                    </a> */}
                                    <a href="#" className="logo" data-bs-toggle="modal" data-bs-target="#logoPrompt">
                                        <img src={resolveMediaUrl(logo)} alt="" />
                                    </a>
                                    <div className="nav-menu">
                                        <ul>
                                            {items?.map((item, i) => (
                                                <li key={i} onClick={() => jumpToPage(item.buttonValue)}>
                                                    <Link to="" className={item.activeStatus == 1 ? 'active' : ''}>{item.Text}</Link>
                                                </li>
                                            ))}

                                        </ul>
                                    </div>
                                    <div className='space'>
                                        {showCurrencyDropdown || showLanguageDropdown ?
                                            <div className="d-flex currency-language">

                                                {showLanguageDropdown && <div className="lang-wrap">
                                                    <Svg name="language-globe" />
                                                    <select className="language">
                                                        <option value="1">English</option>
                                                        <option value="2">Spanish</option>
                                                    </select>
                                                </div>}
                                                {showCurrencyDropdown && 
                                                 <select className='currency' onChange={(e) => currencyChange(e)}>
                                                 <option value={defaultCurrency} selected={changedCurrency == '' || changedCurrency == defaultCurrency ? 'selected' : ''}>{defaultCurrency}</option>
                                                 {currency.map((item, i) => (
                                                     <option value={item} selected={changedCurrency == item ? 'selected' : ''} key={i}>{item}</option>
                                                 ))
                                                 }
                                             </select>}
                                            </div>
                                            :
                                            ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                },
            },
            PageHeaderTransparent: {


                render: ({ logo, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <div className='roi-header-transparent' style={{ opacity: inputOpacity }}>
                            <div className="container">
                                <div className="header-wrapper">
                                    <a className="logo">
                                        <img src={resolveMediaUrl(logo)} alt="" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    )
                },
            },

            // Banner Layouts
            BannerLeftTextRightImage: {

                render: ({ Heading, Description, Button, Padding, Style, image, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-banner-section position-relative ${Padding.bottom} ${Padding.top} ${Style} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                                <div className="container position-relative">
                                    <div className="row align-items-center ">

                                        <div className="col-lg-6">
                                            <div className="banner-text">
                                                <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}>{Heading.title}</h1>

                                                <div className="text-part">
                                                    <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                    </div>
                                                </div>

                                                <div className="button-wrap">
                                                    {Button.buttonicon === "yes" ?

                                                        <button onClick={() => onButtonClick(Button.uuid)} className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                                            <div className="icon">
                                                                <Svg name="roi-button-icon" />
                                                            </div>
                                                        </button>
                                                        :
                                                        <button onClick={() => onButtonClick(Button.uuid)} className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                                    }

                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(image)} className='img-fluid' alt="" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            BannerCenterText: {

                render: ({ Heading, Description, Button, Padding, image, Style, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-banner-section position-relative banner-center-text ${Style} ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: `url("${resolveMediaCssUrl(image)}")`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', opacity: inputOpacity }}>
                                <div className='overlay'></div>
                                <div className="container position-relative">
                                    <div className="row align-items-center justify-content-center">

                                        <div className="col-lg-8">
                                            <div className="banner-text text-center">
                                                <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h1>

                                                <div className="text-part">
                                                    <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                    </div>
                                                </div>

                                                <div className="button-wrap">
                                                    {Button.buttonicon === "yes" ?
                                                        <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                                            <div className="icon">
                                                                <Svg name="roi-button-icon" />
                                                            </div>
                                                        </button>
                                                        :
                                                        <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            //Cards Layouts
            CardLayout1: {
                render: ({ Heading, Description, Padding, Card1, Card2, Card3, Card4, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-cards-section card-layout-1 position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>
                                <div className="card-nav-outer">
                                    <div className="container">
                                        <div className="card-nav d-flex align-items-center justify-content-between">
                                            {/* <div className="card-prev text-start">
                                                <button className='prev-btn card-btn'>Back</button>
                                            </div> */}

                                            <div className="card-next text-end">
                                                {/**Only Hide button in case not to be shown**/}
                                                {/* <button className='next-btn card-btn'>Next</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="container position-relative">

                                    <div className="section-heading mb-3 mb-md-5 text-center">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.descriptionFont}>{Description.text}</p>
                                    </div>

                                    <div className="cards-wrapper">
                                        <div className="row justify-content-center">
                                            <div className="col-lg-4 col-md-6 mb-3">
                                                <div className="card-outer" onClick={() => onButtonClick(Card1.uuid)} >
                                                    <div className="card-inner">
                                                        <div className="text-wrapper">
                                                            <h4>{Card1.title}</h4>
                                                            <p>{Card1.text}</p>
                                                        </div>
                                                        <div className="button-wrapper">
                                                            <button className='btn btn-action'>
                                                                <Svg name="roi-card-button" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-3">
                                                <div className="card-outer" onClick={() => onButtonClick(Card2.uuid)}>
                                                    <div className="card-inner">
                                                        <div className="text-wrapper">
                                                            <h4>{Card2.title}</h4>
                                                            <p>{Card2.text}</p>
                                                        </div>
                                                        <div className="button-wrapper">
                                                            <button className='btn btn-action'>
                                                                <Svg name="roi-card-button" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {(Card3 != undefined && Card3 != null) && (
                                                <div className="col-lg-4 col-md-6 mb-3">
                                                    <div className="card-outer" onClick={() => onButtonClick(Card3.uuid)}>
                                                        <div className="card-inner">
                                                            <div className="text-wrapper">
                                                                <h4>{Card3.title}</h4>
                                                                <p>{Card3.text}</p>
                                                            </div>
                                                            <div className="button-wrapper">
                                                                <button className='btn btn-action'>
                                                                    <Svg name="roi-card-button" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {(Card4 != undefined && Card4 != null) && (
                                                <div className="col-lg-4 col-md-6 mb-3">
                                                    <div className="card-outer" onClick={() => onButtonClick(Card4.uuid)}>
                                                        <div className="card-inner">
                                                            <div className="text-wrapper">
                                                                <h4>{Card4.title}</h4>
                                                                <p>{Card4.text}</p>
                                                            </div>
                                                            <div className="button-wrapper">
                                                                <button className='btn btn-action'>
                                                                    <Svg name="roi-card-button" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </>
                    )

                },
            },


            CardLayout2: {

                render: ({ Heading, Description, Padding, Card1, Card2, Card3, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-cards-section card-layout-2 position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                                <div className="container position-relative">
                                    <div className="section-heading mb-3 mb-md-5 text-center">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.descriptionFont}>{Description.text}</p>
                                    </div>
                                    <div className="cards-wrapper">
                                        <div className="row justify-content-center">
                                            <div className="col-lg-4 col-md-6 mb-3">
                                                <div className="card-outer">
                                                    <div className="card-inner">
                                                        <div className="icon-wrapper">
                                                            <Svg name="roi-card-icon" />
                                                        </div>
                                                        <div className="text-wrapper">
                                                            <h4>{Card1.title}</h4>
                                                            <p>{Card1.text}</p>
                                                        </div>
                                                        <div className="button-wrapper">
                                                            <button className='btn btn-action'>
                                                                <Svg name="roi-card-button" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-3">
                                                <div className="card-outer">
                                                    <div className="card-inner">
                                                        <div className="icon-wrapper">
                                                            <Svg name="roi-card-icon" />
                                                        </div>
                                                        <div className="text-wrapper">
                                                            <h4>{Card2.title}</h4>
                                                            <p>{Card2.text}</p>
                                                        </div>
                                                        <div className="button-wrapper">
                                                            <button className='btn btn-action'>
                                                                <Svg name="roi-card-button" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-3">
                                                <div className="card-outer">
                                                    <div className="card-inner">
                                                        <div className="icon-wrapper">
                                                            <Svg name="roi-card-icon" />
                                                        </div>
                                                        <div className="text-wrapper">
                                                            <h4>{Card3.title}</h4>
                                                            <p>{Card3.text}</p>
                                                        </div>
                                                        <div className="button-wrapper">
                                                            <button className='btn btn-action'>
                                                                <Svg name="roi-card-button" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            //Form Layouts
            SinglePage: {

                render: ({ Heading, Description, Padding, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>

                                <div className="container position-relative">
                                    <DropZone zone="nav-wrapper" allow={["FormNav"]} />
                                    <div className="form-wrapper">
                                        <div className="section-heading mb-3 mb-md-4">
                                            <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                            <p className={Description.descriptionFont}>{Description.text}</p>
                                        </div>
                                        <div className="form-inner">
                                            <DropZone zone="form-wrapper" disallow={["SinglePage", "WizardForm"]} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            FormNav: {

                render: ({ items, hide }) => {
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>

                            <ul className="nav nav-tabs nav-tabs-single">
                                {items.map((item, i) => (
                                    <li className="nav-item" role="presentation" key={i}>
                                        {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                        <button onClick={() => onButtonClick(item.uuid)} className={item.isActive == true ? 'nav-link active' : 'nav-link'}>{item.Title}</button>
                                    </li>
                                ))}
                            </ul>


                        </>
                    )

                },
            },

            WizardForm: {

                render: ({ Padding, items, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                                <div className="container position-relative">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">

                                        {items.map((item, i) => (
                                            <li className="nav-item" role="presentation" key={i}>
                                                {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                                <button className={i === 0 ? 'nav-link active' : 'nav-link'} id={`tab-${i}`} data-bs-toggle="tab" data-bs-target={`#tab-${i}-pane`} type="button" role="tab" aria-controls={`tab-${i}-pane`} aria-selected="false">{item.Title}</button>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="form-wrapper">
                                        <div className="tab-content" id="myTabContent">
                                            {items.map((item, i) => (
                                                <div key={i} className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>
                                                    <div className="section-heading mb-3 mb-md-4">
                                                        <h2 className={`heading fw-700 fs-40`}>{item.Title}</h2>
                                                        <p className='fs-22'>{item.Description}</p>
                                                    </div>
                                                    <div className="form-inner">
                                                        <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </>
                    )

                },
            },

            //Form Elements

            InputTextField: {

                render: ({ label, showLabel, disableEditing, value, placeholder, required, errorMessage, hint, hide, Prefix, uuid, tabIndex, Style, Font, Border, Padding, Margin }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                                {
                                    opacity: inputOpacity,
                                    margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                                }
                            }>
                                {showLabel && <label className='field-label' for={uuid}>{label} {required && <span className='required'>*</span>}</label>}
                                <div className="position-relative">
                                
                                {(() => {
                                    if (Prefix === 'currency') {
                                        return (
                                        <input {...(disableEditing ? {disabled: true} : {})} type="text" className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder}
                                            // value={roiActionArr[uuid] ? ((roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : value) : value}
                                            defaultValue={(CurrencyFormatter({ amount: parseFloat(value) })).normalize()}
                                            id={uuid}
                                            tabIndex={tabIndex ?? ''}
                                            // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                                            required={required} onBlur={(e) => handleChange(uuid, e, required)} style={{
                                                backgroundColor: `${Style?.BackgroundColor}`,
                                                color: `${Style?.Color}`,

                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                                borderStyle: `${Border?.BorderStyle}`,
                                                borderColor: `${Border?.BorderColor}`,
                                                borderWidth: `${Border?.BorderWidth}px`,
                                                borderRadius: `${Border?.BorderRadius}px`,
                                                height: `${Style?.Height}px`,
                                                textAlign: Font?.Align,
                                            }} />
                                            
                                        )
                                    }
                                    else {
                                        return (
                                            <input type="text" className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder}
                                            // value={roiActionArr[uuid] ? ((roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : value) : value}
                                            defaultValue={value}
                                            id={uuid}
                                            tabIndex={tabIndex ?? ''}
                                            // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                                            required={required} onBlur={(e) => handleChange(uuid, e, required)} style={{
                                                backgroundColor: `${Style?.BackgroundColor}`,
                                                color: `${Style?.Color}`,

                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                                borderStyle: `${Border?.BorderStyle}`,
                                                borderColor: `${Border?.BorderColor}`,
                                                borderWidth: `${Border?.BorderWidth}px`,
                                                borderRadius: `${Border?.BorderRadius}px`,
                                                height: `${Style?.Height}px`,
                                                textAlign: Font?.Align,
                                            }} />
                                        )
                                    }
                                })()}
                                    
                                    {hint &&
                                        <div className="hint">
                                            <button className="info"><Svg name="hint-button" /></button>
                                            <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                            </div>
                                        </div>
                                    }
                                </div>

                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )
                },

            },

            InputNumberField: {

                render: ({ label, showLabel, value, placeholder, required, errorMessage, hint, hide, Prefix, Style, Font, Border, Padding, Margin, uuid, tabIndex }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={{
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,

                            }} >
                                {showLabel && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                <div className="position-relative">
                                    {Prefix == 'none' &&
                                        <input type="number" className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`}
                                            placeholder={placeholder}
                                            defaultValue={value}
                                            id={uuid}
                                            tabIndex={tabIndex ?? ''}
                                            required={required} onBlur={(e) => handleChange(uuid, e, required)}
                                            style={{
                                                backgroundColor: `${Style?.BackgroundColor}`,
                                                color: `${Style?.Color}`,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                                borderStyle: `${Border?.BorderStyle}`,
                                                borderColor: `${Border?.BorderColor}`,
                                                borderWidth: `${Border?.BorderWidth}px`,
                                                borderRadius: `${Border?.BorderRadius}px`,
                                                height: `${Style?.Height}px`,
                                                textAlign: Font?.Align,
                                            }}
                                        />
                                    }

                                    {Prefix == '%' &&
                                        <div className="input-group percent">
                                            <input type="number" className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`}
                                                placeholder={placeholder}
                                                defaultValue={value}
                                                tabIndex={tabIndex ?? ''}
                                                required={required} onBlur={(e) => handleChange(uuid, e)}
                                                style={{
                                                    backgroundColor: `${Style?.BackgroundColor}`,
                                                    color: `${Style?.Color}`,
                                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                                    borderStyle: `${Border?.BorderStyle}`,
                                                    borderColor: `${Border?.BorderColor}`,
                                                    borderWidth: `${Border?.BorderWidth}px`,
                                                    borderRadius: `${Border?.BorderRadius}px`,
                                                    height: `${Style?.Height}px`,
                                                    textAlign: Font?.Align,
                                                }}
                                            />
                                            <span className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`} style={{
                                                color: `${Style?.Color}`,
                                            }}>%</span>
                                        </div>

                                    }

                                    {Prefix == 'currency' &&
                                        <div className="input-group currency">
                                            <span className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`} style={{
                                                color: `${Style?.Color}`,
                                            }} dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                            {/**Change this currency depending upon default currency**/}
                                            <input type="number" className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`}
                                                placeholder={placeholder}
                                                defaultValue={value}
                                                tabIndex={tabIndex ?? ''}
                                                required={required} onBlur={(e) => handleChange(uuid, e)}
                                                style={{
                                                    backgroundColor: `${Style?.BackgroundColor}`,
                                                    color: `${Style?.Color}`,
                                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                                    borderStyle: `${Border?.BorderStyle}`,
                                                    borderColor: `${Border?.BorderColor}`,
                                                    borderWidth: `${Border?.BorderWidth}px`,
                                                    borderRadius: `${Border?.BorderRadius}px`,
                                                    height: `${Style?.Height}px`,
                                                    textAlign: Font?.Align,
                                                }}
                                            />

                                        </div>
                                    }



                                    {hint &&
                                        <div className="hint">
                                            <button className="info"><Svg name="hint-button" /></button>
                                            <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                            </div>
                                        </div>
                                    }
                                </div>

                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )

                },
            },

            TextareaField: {

                render: ({ label, value, placeholder, required, errorMessage, hide, Style, Font, Border, Padding, Margin, showLabel }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                                {
                                    opacity: inputOpacity,
                                    margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                                }
                            }>
                                {showLabel && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                <textarea className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} value={value}
                                    style={{
                                        backgroundColor: `${Style?.BackgroundColor}`,
                                        color: `${Style?.Color}`,

                                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                        borderStyle: `${Border?.BorderStyle}`,
                                        borderColor: `${Border?.BorderColor}`,
                                        borderWidth: `${Border?.BorderWidth}px`,
                                        borderRadius: `${Border?.BorderRadius}px`,
                                        height: `${Style?.Height}px`,
                                        textAlign: Font?.Align,
                                    }} />

                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )

                },
            },

            Dropdown: {

                render: ({ label, showLabel, required, errorMessage, items, hide, Style, Font, Border, Padding, Margin, uuid }) => {
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                                {
                                    opacity: inputOpacity,
                                    margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                                }
                            }>

                                {showLabel && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                <select className={`form-control ${Font?.fontWeight} ${Font?.fontSize} ${errorMessage ? 'error' : ''}`}
                                    onChange={(e) => handleDropdownChange(uuid, e)}
                                    style={{
                                        backgroundColor: `${Style?.BackgroundColor}`,
                                        backgroundSize: `${Style?.DropdownSize}px`,
                                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                        borderStyle: `${Border?.BorderStyle}`,
                                        borderColor: `${Border?.BorderColor}`,
                                        borderWidth: `${Border?.BorderWidth}px`,
                                        borderRadius: `${Border?.BorderRadius}px`,
                                        height: `${Style?.Height}px`
                                    }}
                                    defaultValue={changedDropdown[uuid]}
                                >
                                    <option value>--Select--</option>
                                    {items.map((item, i) => (
                                        <option key={i} value={item.Option} >{item.Option}</option>
                                    ))}
                                </select>


                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )

                },
            },


            Checkbox: {

                render: ({ label, required, errorMessage, items, ID, hide, Margin, Style }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                                {
                                    opacity: inputOpacity,
                                    margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                                }}>
                                {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}

                                <div className="roi-check-wrap">
                                    {items.map((item, i) => (

                                        <div className="form-check" key={i}>
                                            <input className="form-check-input" name={ID} type="checkbox" checked={(item.value == '1') ? 'checked' : ''} onChange={() => onCheckBoxClick(item.uuid)} />
                                            <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                                {item.Option}
                                            </label>
                                        </div>
                                    ))}

                                </div>
                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )

                },
            },

            Radio: {

                render: ({ label, required, errorMessage, items, ID, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                                {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}

                                <div className="roi-check-wrap">
                                    {items.map((item, i) => (

                                        <div className="form-check" key={i}>
                                            <input className="form-check-input" name={ID} type="radio" defaultValue id={`${ID}-${i}`} />
                                            <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                                {item.Option}
                                            </label>
                                        </div>
                                    ))}

                                </div>
                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )

                },
            },


            PhoneNumber: {

                render: ({ label, showLabel, placeholder, required, errorMessage, value, hide, Style, Font, Border, Padding, Margin }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                                {
                                    opacity: inputOpacity,
                                    margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                                }
                            }>
                                {showLabel && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                <input type="text" className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} style={{
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Color}`,

                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                    borderStyle: `${Border?.BorderStyle}`,
                                    borderColor: `${Border?.BorderColor}`,
                                    borderWidth: `${Border?.BorderWidth}px`,
                                    borderRadius: `${Border?.BorderRadius}px`,
                                    height: `${Style?.Height}px`,
                                    textAlign: Font?.Align,
                                }} />
                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )

                },
            },

            Email: {

                render: ({ label, placeholder, required, errorMessage, value, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                                {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} />
                                {errorMessage && <div className="input-error">{errorMessage}</div>}
                            </div>
                        </>
                    )

                },
            },

            Date: {

                render: ({ label, required, errorMessage, hide, onChange, placeholder }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                                {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} onChange={onChange} />

                                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                                {/* <DateField /> */}
                                {errorMessage && <div className="input-error">{errorMessage}</div>}

                            </div>
                        </>
                    )

                },
            },

            Range: {

                render: ({ label, required, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                                {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                                <Range />

                            </div>
                        </>
                    )

                },
            },

            Toggle: {

                render: ({ label, required, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                                {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                                <div className="check-switch">
                                    <label>No</label>
                                    <input
                                        id="agree-check"
                                        type="checkbox"
                                        defaultChecked
                                    />
                                    <label>Yes</label>

                                </div>

                            </div>
                        </>
                    )

                },
            },

            Button: {

                render: ({ buttonText, buttonAction, conditionalLogic, buttonLink, buttonStyle, buttonicon, icon, iconsize, hide, uuid, customStyle, Style, spacing, iconPosition }) => {
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="button-wrap" style={{ opacity: inputOpacity }}>
                            
                            
                                {(() => {
                                    if (buttonAction === "OpenPopup") {
                                        return (

                                            (
                                                buttonicon === "yes" ? (
                                                    <button 
                                                        data-bs-toggle="modal" 
                                                        data-bs-target="#reportModal" 
                                                        onClick={() => onButtonClick(uuid)} 
                                                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} 
                                                        type="submit" 
                                                        style={customStyle ? {
                                                            backgroundColor: Style?.BackgroundColor,
                                                            color: Style?.Font?.Color,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,
                                                            gap: `${spacing ? `${spacing}px` : '20px'}`,
                                                        } : { gap: `${spacing ? `${spacing}px` : '20px'}` }}
                                                    >
                                                        {iconPosition === "left" ? (
                                                            customStyle ? (
                                                                <>
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                    {buttonText}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                    {buttonText}
                                                                </>
                                                            )
                                                        ) : iconPosition === "right" ? (
                                                            customStyle ? (
                                                                <>
                                                                    {buttonText}
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {buttonText}
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                </>
                                                            )
                                                        ) : (
                                                            <>
                                                                {buttonText}
                                                                <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                {
                                                                    width: `${iconsize?.Width}px`,
                                                                    height: `${iconsize?.Height}px`,
                                                                }
                                                                } />
                                                            </>
                                                        )}
                                                    </button>
                                                ) : (
                                                    <button
                                                        data-bs-toggle="modal" 
                                                        data-bs-target="#reportModal" 
                                                        onClick={() => onButtonClick(uuid)} 
                                                        className={`btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} 
                                                        type="submit" 
                                                        style={customStyle ? {
                                                            backgroundColor: Style?.BackgroundColor,
                                                            color: Style?.Font?.Color,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,
                                                        } : {}}
                                                    >
                                                        {buttonText}
                                                    </button>
                                                )
                                            )

                                            
                                        );

                                    }
                                    else if (buttonAction === "ClosePopup") {
                                        return (

                                            (
                                                buttonicon === "yes" ? (
                                                    <button 
                                                        data-bs-dismiss="modal" 
                                                        onClick={() => onButtonClick(uuid)} 
                                                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} 
                                                        type="submit" 
                                                        style={customStyle ? {
                                                            backgroundColor: Style?.BackgroundColor,
                                                            color: Style?.Font?.Color,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,
                                                            gap: `${spacing ? `${spacing}px` : '20px'}`,
                                                        } : { gap: `${spacing ? `${spacing}px` : '20px'}` }}
                                                    >
                                                        {iconPosition === "left" ? (
                                                            customStyle ? (
                                                                <>
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                    {buttonText}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                    {buttonText}
                                                                </>
                                                            )
                                                        ) : iconPosition === "right" ? (
                                                            customStyle ? (
                                                                <>
                                                                    {buttonText}
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {buttonText}
                                                                    <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${iconsize?.Width}px`,
                                                                        height: `${iconsize?.Height}px`,
                                                                    }
                                                                    } />
                                                                </>
                                                            )
                                                        ) : (
                                                            <>
                                                                {buttonText}
                                                                <img src={resolveMediaUrl(icon)} alt="" className={`btn-icon`} style={
                                                                {
                                                                    width: `${iconsize?.Width}px`,
                                                                    height: `${iconsize?.Height}px`,
                                                                }
                                                                } />
                                                            </>
                                                        )}
                                                    </button>
                                                ) : (
                                                    <button
                                                        data-bs-dismiss="modal" 
                                                        onClick={() => onButtonClick(uuid)} 
                                                        className={`btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} 
                                                        type="submit" 
                                                        style={customStyle ? {
                                                            backgroundColor: Style?.BackgroundColor,
                                                            color: Style?.Font?.Color,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,
                                                        } : {}}
                                                    >
                                                        {buttonText}
                                                    </button>
                                                )
                                            )

                                            
                                        );

                                    }
                                    else {
                                        return (

                                            (
                                                buttonicon === "yes" ? (
                                                    <button 
                                                        onClick={() => onButtonClick(uuid)} 
                                                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} 
                                                        type="submit" 
                                                        style={customStyle ? {
                                                            backgroundColor: Style?.BackgroundColor,
                                                            color: Style?.Font?.Color,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,
                                                            gap: `${spacing ? `${spacing}px` : '20px'}`,
                                                        } : { gap: `${spacing ? `${spacing}px` : '20px'}` }}
                                                    >
                                                        {iconPosition === "left" ? (
                                                            customStyle ? (
                                                                <>
                                                                    <Svg name="roi-button-icon-2" /> {buttonText}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="icon">
                                                                        <Svg name="roi-button-icon" />
                                                                    </div>
                                                                    {buttonText}
                                                                </>
                                                            )
                                                        ) : iconPosition === "right" ? (
                                                            customStyle ? (
                                                                <>
                                                                    {buttonText} <Svg name="roi-button-icon-2" />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {buttonText}
                                                                    <div className="icon">
                                                                        <Svg name="roi-button-icon" />
                                                                    </div>
                                                                </>
                                                            )
                                                        ) : (
                                                            <>
                                                                {buttonText}
                                                                <div className="icon">
                                                                    <Svg name="roi-button-icon" />
                                                                </div>
                                                            </>
                                                        )}
                                                    </button>
                                                ) : (
                                                    <button
                                                        onClick={() => onButtonClick(uuid)} 
                                                        className={`btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} 
                                                        type="submit" 
                                                        style={customStyle ? {
                                                            backgroundColor: Style?.BackgroundColor,
                                                            color: Style?.Font?.Color,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,
                                                        } : {}}
                                                    >
                                                        {buttonText}
                                                    </button>
                                                )
                                            )

                                            
                                        );

                                    }
                                    
                                })()}


                                


                            </div>
                        </>
                    )

                },
            },

            // Button: {
            //     render: ({ Button, hide }) => {
            //         // Render nothing if hide is true
            //         if (hide) {
            //             return null;
            //         }

            //         // Calculate opacity based on hide value
            //         const inputOpacity = hide ? 0.5 : 1;

            //         return (
            //             <>
            //                 <div className="button-wrap" style={{ opacity: inputOpacity }}>
            //                     {Button.buttonicon === "yes" ?

            //                         <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
            //                             <div className="icon">
            //                                 <Svg name="roi-button-icon" />
            //                             </div>
            //                         </button>
            //                         :
            //                         <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
            //                     }

            //                 </div>
            //             </>
            //         )

            //     },
            // },


            //Report
            ReportPage: {

                render: ({ Heading, Description, Padding, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>

                            <div className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                                <div className="container position-relative">
                                    <div className="heading-currency-wrapper d-lg-flex mb-3 mb-lg-4 align-items-center">
                                        <div className="curecny-dropdown mb-3 mb-lg-0 order-2">
                                            <select className='form-control form-select' onChange={(e) => currencyChange(e)}>
                                                <option value={defaultCurrency} selected={changedCurrency == '' || changedCurrency == defaultCurrency ? 'selected' : ''}>{defaultCurrency}</option>
                                                {currency.map((item, i) => (
                                                    <option value={item} selected={changedCurrency == item ? 'selected' : ''} key={i}>{item}</option>
                                                ))
                                                }
                                            </select>
                                        </div>
                                        <div className="section-heading flex-grow-1 order-1">
                                            <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                            <p className={Description.Font}>{Description.text}</p>
                                        </div>
                                    </div>
                                    <div className="stats-section stats-section-custom">
                                        <div className="row">
                                            <div className="col-lg-8 mb-3 mb-lg-0">
                                                <div className="total-wrapper-custom mb-3 mb-lg-4">
                                                    <DropZone zone="total-wrapper" />
                                                </div>
                                                <div className="chart-wrapper-custom mb-3 mb-lg-4">
                                                    <DropZone zone="chart-wrapper" />
                                                </div>
                                                <div className="custom-table-wrapper report-accordion-wrapper report-pg-table mb-3 mb-lg-4">
                                                    <DropZone zone="table-wrapper" />
                                                </div>

                                            </div>
                                            <div className="col-lg-4">
                                                <div className="download-wrapper-custom mb-3 mb-lg-4">
                                                    <DropZone zone="download-wrapper" />
                                                </div>
                                                <div className="card-wrapper-custom">
                                                    <DropZone zone="card-wrapper" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            CardSection: {

                render: ({ items, hide, Text }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="row" style={{ opacity: inputOpacity }}>
                                {items.map((item, i) => (
                                    <div className="col-lg-4 col-md-4 mb-3" key={i}>
                                        <div className="stat-wrap">
                                            <div className="stat-heading">
                                                <div className="icon">
                                                    <img src={resolveMediaUrl(item.icon)} alt="" />
                                                </div>
                                                <div className={`text ${Text.titleFont} ${Text.fontWeight}`}>{item.Title}</div>
                                            </div>
                                            <div className="stat-content-wrapper d-flex flex-column">
                                                <div className="d-flex flex-column flex-grow-1">
                                                    <div className="value-section value-section-1 d-flex align-items-center">
                                                        <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle1}</div>
                                                        <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                            {CurrencyFormatter({ amount: parseFloat(item.Value1) })}
                                                        </div>
                                                    </div>
                                                    <div className="value-section value-section-2 d-flex align-items-center">
                                                        <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle2}</div>
                                                        <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                            {CurrencyFormatter({ amount: parseFloat(item.Value2) })}
                                                        </div>
                                                    </div>
                                                    <div className="value-section value-section-2 d-none align-items-center">
                                                        <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle3}</div>
                                                        <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                            {item.Value3}
                                                        </div>
                                                    </div>
                                                    <div className="value-section value-section-2 d-none align-items-center">
                                                        <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle4}</div>
                                                        <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                            {item.Value4}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="action">
                                                    <a data-bs-toggle="modal" data-bs-target="#reportModal" onClick={() => onButtonClick(item.uuid)} className='fs-16 fw-700'>{item.ActionText} <span className="icon" >
                                                        <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx={10} cy={10} r={10} fill="#E60000" />
                                                            <path d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )
                },
            },

            ResultCard: {

                render: ({ Card1, Card2, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="total-wrapper" style={{ opacity: inputOpacity }}>
                                <div className="total-inner bg-1">
                                    <h5 className='fs-16 fw-700'>{Card1.title}</h5>
                                    <p className='fs-36 fw-300'>{CurrencyFormatter({ amount: parseFloat(Card1.value) })}</p>
                                </div>
                                <div className="total-inner bg-2">
                                    <h5 className='fs-16 fw-700'>{Card2.title}</h5>
                                    <p className='fs-36 fw-300'>{CurrencyFormatter({ amount: parseFloat(Card2.value) })}</p>
                                </div>
                            </div>

                        </>
                    )
                },
            },

            ChartCard: {

                render: ({ Heading, hide, Chart1, Chart2, Chart3, Chart4 }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                                <div className="stat-heading">
                                    <div className="icon d-none">
                                        <img src={Heading.icon} alt="" />
                                    </div>
                                    <div className={`text ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</div>

                                    <div className="switch-btn">
                                        <div className='switch-nav'>
                                            <input
                                                id="microsoft"
                                                type="radio"
                                                name="company"
                                                value="microsoft"
                                                checked={selectedCompany === 'microsoft'}
                                                onChange={handleCompanyChange}
                                            />
                                            <label htmlFor='microsoft'>Microsoft</label>

                                            <input
                                                id='vbuc'
                                                type="radio"
                                                name="company"
                                                value="vbuc"
                                                checked={selectedCompany === 'vbuc'}
                                                onChange={handleCompanyChange}
                                            />
                                            <label htmlFor='vbuc'>VBUC
                                            </label>
                                        </div>

                                        <div className='switch-nav'>


                                            <input
                                                id="year1"
                                                type="radio"
                                                name="year"
                                                value="year1"
                                                checked={selectedYear === 'year1'}
                                                onChange={handleYearChange}
                                            />
                                            <label htmlFor='year1'> First Year</label>

                                            <input
                                                id='year3'
                                                type="radio"
                                                name="year"
                                                value="year3"
                                                checked={selectedYear === 'year3'}
                                                onChange={handleYearChange}
                                            />
                                            <label htmlFor='year3'>Three Years </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="stat-content-wrapper pt-4">
                                    {selectedCompany === 'vbuc' && selectedYear === 'year1' && (
                                        <ReactEcharts style={chartStyle} option={pieChart(Chart1.items)} />
                                    )}
                                    {selectedCompany === 'vbuc' && selectedYear === 'year3' && (
                                        <ReactEcharts style={chartStyle} option={pieChart(Chart2.items)} />
                                    )}

                                    {selectedCompany === 'microsoft' && selectedYear === 'year1' && (
                                        <ReactEcharts style={chartStyle} option={pieChart(Chart3.items)} />
                                    )}

                                    {selectedCompany === 'microsoft' && selectedYear === 'year3' && (
                                        <ReactEcharts style={chartStyle} option={pieChart(Chart4.items)} />
                                    )}


                                </div>
                            </div>
                        </>
                    )
                },
            },

            DownloadCard: {

                render: ({ Heading, Padding, Button, image, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`save-report-section h-100 d-flex align-items-end`} style={
                                {
                                    backgroundImage: `url("${resolveMediaCssUrl(image)}")`,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'cover',
                                    opacity: inputOpacity,
                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                }
                            }>

                                <div className="text-wrapper">
                                    <h4 className={`${Heading?.fontWeight} ${Heading?.titleFont}`}
                                        style={{
                                            color: Heading?.Color
                                        }}
                                    >{Heading.title}</h4>

                                    <div className="button-wrap">

                                        {Button.buttonicon === "yes" ?
                                            <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                                <div className="icon">
                                                    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8 2.33334V13.5533" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </button>
                                            :
                                            <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            //Report Single page


            ReportSection: {


                render: ({ Heading, Description, Padding, items, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                                <div className="container position-relative">
                                    <DropZone zone={`summary-heading`} />
                                    <div className="row">
                                        <div className="col-xl-3 col-lg-4">
                                            <DropZone zone={`summary-details`} />
                                        </div>
                                        <div className="col-xl-9 col-lg-8">
                                            <div className="report-accordion-wrapper">
                                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                    {items.map((item, i) => (
                                                        <li className="nav-item" role="presentation" key={i}>
                                                            {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                                            <button className={item.isActive === true ? 'nav-link active' : 'nav-link'} onClick={() => openPopup(item.buttonValue)}>{item.Title}</button>
                                                        </li>
                                                    ))}
                                                </ul>
                                                <div className="form-wrapper">
                                                    {/* <div className="tab-content" id="myTabContent"> */}
                                                    {/* {items.map((item, i) => ( */}
                                                    {/* <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}> */}

                                                    <div className="form-inner">
                                                        <DropZone zone={`wizard-form-wrapper`} disallow={["SinglePage", "WizardForm"]} />
                                                    </div>
                                                    {/* </div> */}
                                                    {/* ))} */}
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </>
                    )

                },
            },

            ReportTable: {

                render: ({ Heading, Table, Headings, ColumnSettings, items, Calculations, Test, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="accordion-item" style={{ opacity: inputOpacity }}>
                                {Heading?.title && <h2 className="fs-20 fw-700 accordion-button">
                                    {Heading.title}
                                </h2>}

                                <div className="accordion-body report-accordion-wrapper">
                                    <div className="table-wrapper">
                                        <div className="table-responsive">
                                            <table className="table">
                                                {Table.FirstRow && <thead>
                                                    <tr>
                                                        <th scope="col" style={{ width: `${ColumnSettings.FirstColSpan}'px'` }} className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>{Headings.Cell1}</th>
                                                        <th scope="col" style={{ width: `${ColumnSettings.SecondColSpan}px` }} className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>{Headings.Cell2}</th>
                                                        <th scope="col" style={{ width: `${ColumnSettings.ThirdColSpan}px` }} className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>{Headings.Cell3}</th>
                                                        <th scope="col" style={{ width: `${ColumnSettings.FourthColSpan}px` }} className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>{Headings.Cell4}</th>
                                                    </tr>
                                                </thead>}

                                                <tbody>
                                                    {items.map((item, i) => (
                                                        <tr key={i} className={`${Table.LastRow && `table-last-row`}`}>
                                                            <td className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>
                                                                {item.Cell1isEditable ?
                                                                    <input type="text" className="form-control first-column" defaultValue={item.Cell1Data} /> :
                                                                    item.Cell1Data
                                                                }
                                                            </td>


                                                            <td className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>
                                                                {(() => {
                                                                    if (item.Cell2isEditable && item.Cell2EditStyle === 'percentage') {
                                                                        return (
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} onBlur={(e) => handleChange(item.Cell2uuid, e)} />
                                                                                <span className="input-group-text" id="basic-addon2">%</span>
                                                                            </div>
                                                                        );

                                                                    }
                                                                    else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'percentage') {
                                                                        return (
                                                                            item.Cell2Data + '%'
                                                                        );
                                                                    }
                                                                    else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'currency') {
                                                                        return (<>
                                                                            {CurrencyFormatter({ amount: parseFloat(item.Cell2Data) })}
                                                                        </>
                                                                        );
                                                                    }

                                                                    else if (item.Cell2isEditable && item.Cell2EditStyle === 'currency') {
                                                                        return (
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} onBlur={(e) => handleChange(item.Cell2uuid, e)} />
                                                                                <span className="input-group-text" id="basic-addon2" dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                                                            </div>
                                                                        );
                                                                    } else if (item.Cell2isEditable && item.Cell2EditStyle === 'number') {
                                                                        return (
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} onBlur={(e) => handleChange(item.Cell2uuid, e)} />
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            item.Cell2Data
                                                                        );
                                                                    }
                                                                })()}

                                                            </td>
                                                            <td className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>
                                                                {(() => {
                                                                    if (item.Cell3isEditable && item.Cell3EditStyle === 'percentage') {
                                                                        return (
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} onBlur={(e) => handleChange(item.Cell3uuid, e)} />
                                                                                <span className="input-group-text" id="basic-addon2">%</span>
                                                                            </div>
                                                                        );

                                                                    }
                                                                    else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'percentage') {
                                                                        return (
                                                                            item.Cell3Data + '%'
                                                                        );
                                                                    }
                                                                    else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'currency') {
                                                                        return (<>
                                                                            {CurrencyFormatter({ amount: parseFloat(item.Cell3Data) })}
                                                                        </>
                                                                        );
                                                                    }

                                                                    else if (item.Cell3isEditable && item.Cell3EditStyle === 'currency') {
                                                                        return (
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} onBlur={(e) => handleChange(item.Cell3uuid, e)} />
                                                                                <span className="input-group-text" id="basic-addon2" dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                                                            </div>
                                                                        );
                                                                    } else if (item.Cell3isEditable && item.Cell3EditStyle === 'number') {
                                                                        return (
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} onBlur={(e) => handleChange(item.Cell3uuid, e)} />
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            item.Cell3Data
                                                                        );
                                                                    }
                                                                })()}
                                                            </td>
                                                            <td className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>

                                                                {(() => {
                                                                    if (item.Cell4isEditable && item.Cell4EditStyle === 'percentage') {
                                                                        return (
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} onBlur={(e) => handleChange(item.Cell4uuid, e)} />
                                                                                <span className="input-group-text" id="basic-addon2">%</span>
                                                                            </div>
                                                                        );

                                                                    }
                                                                    else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'percentage') {
                                                                        return (
                                                                            item.Cell4Data + '%'
                                                                        );
                                                                    }
                                                                    else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'currency') {
                                                                        return (
                                                                            <>
                                                                                {CurrencyFormatter({ amount: parseFloat(item.Cell4Data) })}
                                                                            </>
                                                                        );
                                                                    }

                                                                    else if (item.Cell4isEditable && item.Cell4EditStyle === 'currency') {
                                                                        return (
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} onBlur={(e) => handleChange(item.Cell4uuid, e)} />
                                                                                <span className="input-group-text" id="basic-addon2" dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                                                            </div>
                                                                        );
                                                                    } else if (item.Cell4isEditable && item.Cell4EditStyle === 'number') {
                                                                        return (
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} onBlur={(e) => handleChange(item.Cell4uuid, e)} />
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            item.Cell4Data
                                                                        );
                                                                    }
                                                                })()}



                                                            </td>
                                                        </tr>
                                                    ))}




                                                </tbody>
                                                {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{Calculations.Cell1}</td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{Calculations.Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },


            // Download Report 
            DownloadReportBanner: {

                render: ({ Heading, Description, Padding, logo, image, backgroundImage, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                                <div className={`style3 dwn-report-section roi-banner-section position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: `url("${resolveMediaCssUrl(backgroundImage)}")`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

                                    <div className="container position-relative">
                                        <div className="logo-wrap">
                                            <Link to="">
                                                <img src={resolveMediaUrl(logo)} alt="" />
                                            </Link>
                                        </div>
                                        <div className="row align-items-center ">
                                            <div className="col-lg-12">
                                                <div className="banner-text">
                                                    <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}>{Heading.title}</h1>

                                                    <div className="text-part">
                                                        <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="img-wrapper">
                                                    <img src={resolveMediaUrl(image)} className='img-fluid' alt="" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },
            DownloadReportPage: {

                render: ({ Heading, Description, Padding, logo, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                                <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>
                                    <div className="container position-relative">
                                        <div className="logo-wrap">
                                            <Link to="">
                                                <img src={resolveMediaUrl(logo)} alt="" />
                                            </Link>
                                        </div>
                                        <div className="section-heading mb-3 mb-md-4">
                                            <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                            <p className={Description.Font}>{Description.text}</p>
                                        </div>

                                        <div className="stats-section">
                                            <div className="row">
                                                <div className="col-lg-12 mb-2">
                                                    <DropZone zone="card-wrapper" />
                                                </div>

                                                <div className="col-lg-12 mb-2">
                                                    <DropZone zone="total-wrapper" />

                                                </div>

                                                <div className="col-lg-12">
                                                    <DropZone zone="chart-wrapper" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                },
            },

            DownloadCardSection: {

                render: ({ items, hide, Text }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="row gx-2" style={{ opacity: inputOpacity }}>
                                {items.map((item, i) => (
                                    <div className="col-lg-4 col-md-4 mb-2" key={i}>
                                        <div className="stat-wrap">
                                            <div className="stat-heading">
                                                <div className="icon">
                                                    <img src={resolveMediaUrl(item.icon)} alt="" />
                                                </div>
                                                <div className={`text ${Text.titleFont} ${Text.fontWeight}`}>{item.Title}</div>
                                            </div>
                                            <div className="stat-content-wrapper d-flex flex-column">
                                                <div className="d-flex flex-column flex-grow-1">
                                                    <div className="value-section value-section-1 d-flex align-items-center">
                                                        <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle1}</div>
                                                        <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                            {item.Value1}
                                                        </div>
                                                    </div>
                                                    <div className="value-section value-section-2 d-flex align-items-center">
                                                        <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle2}</div>
                                                        <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                            {item.Value2}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="action">
                                                    <a href="" className='fs-16 fw-700'>{item.ActionText} <span className="icon">
                                                        <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx={10} cy={10} r={10} fill="#E60000" />
                                                            <path d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )
                },
            },

            DownloadResultCard: {

                render: ({ Card1, Card2, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="total-wrapper row gx-0 flex-row" style={{ opacity: inputOpacity }}>
                                <div className="total-inner bg-1 col-6">
                                    <h5 className='fs-16 fw-700 text-center'>{Card1.title}</h5>
                                    <p className='fs-48 fw-300 text-center'>{Card1.description}</p>
                                </div>
                                <div className="total-inner bg-2 col-6">
                                    <h5 className='fs-16 fw-700 text-center'>{Card2.title}</h5>
                                    <p className='fs-48 fw-300 text-center'>{Card2.description}</p>
                                </div>
                            </div>

                        </>
                    )
                },
            },

            DownloadChartCard: {

                render: ({ Chart1, Chart2, Heading, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                                <div className="stat-heading">
                                    <div className="icon">
                                        <img src={Heading.icon} alt="" />
                                    </div>
                                    <div className={`text ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</div>


                                </div>

                                <div className="stat-content-wrapper">
                                    <div className="tab-content" id="myTabContent">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                {Chart1.chooseChart === "pie" ? <ReactEcharts style={chartStyle} option={OneYearChartOptions} /> : <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} />}
                                            </div>
                                            <div className="col-sm-6">
                                                {Chart2.chooseChart === "bar" ? <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} /> : <ReactEcharts style={chartStyle} option={OneYearChartOptions} />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                },
            },

            DownloadReportSection: {

                render: ({ Heading, Description, Padding, items, logo, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                                <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>

                                    <div className="container position-relative">
                                        <div className="logo-wrap">
                                            <Link to="">
                                                <img src={resolveMediaUrl(logo)} alt="" />
                                            </Link>
                                        </div>
                                        <div className="section-heading mb-3 mb-md-4">
                                            <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                            <p className={Description.Font}>{Description.text}</p>
                                        </div>
                                        <div className="report-accordion-wrapper">

                                            <div className="form-wrapper">
                                                <div className="tab-content" id="myTabContent">
                                                    {items.map((item, i) => (
                                                        <div key={i} className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>

                                                            <div className="form-inner">
                                                                <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },

            DownloadReportTable: {

                render: ({ Heading, Table, Headings, ColumnSettings, items, Calculations, Test, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="accordion-item" style={{ opacity: inputOpacity }}>
                                <h2 className="fs-14 fw-700 accordion-button">
                                    {Heading.title}
                                </h2>
                                <div className="accordion-body">
                                    <div className="table-wrapper">
                                        <div className="table-responsive">
                                            <table className="table">
                                                {Table.FirstRow && <thead>
                                                    <tr>
                                                        <th scope="col" style={{ width: `${ColumnSettings.FirstColSpan}'px'` }} className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>{Headings.Cell1}</th>
                                                        <th scope="col" style={{ width: `${ColumnSettings.SecondColSpan}px` }} className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>{Headings.Cell2}</th>
                                                        <th scope="col" style={{ width: `${ColumnSettings.ThirdColSpan}px` }} className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>{Headings.Cell3}</th>
                                                        <th scope="col" style={{ width: `${ColumnSettings.FourthColSpan}px` }} className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>{Headings.Cell4}</th>
                                                    </tr>
                                                </thead>}

                                                <tbody>
                                                    {items.map((item, i) => {
                                                        // console.log('items', i);
                                                        // if (items.length-1 != i) { 
                                                        //console.log("items", items.length - 1, i);
                                                        return (
                                                            <tr key={i}>
                                                                <td className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>
                                                                    {item.Cell1isEditable ?
                                                                        <input type="text" className="form-control first-column" defaultValue={item.Cell1Data} onBlur={(e) => handleChange(item.Cell1uuid, e)} /> :
                                                                        item.Cell1Data
                                                                    }
                                                                </td>


                                                                <td className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>
                                                                    {(() => {
                                                                        if (item.Cell2isEditable && item.Cell2EditStyle === 'percentage') {
                                                                            return (
                                                                                <div className="input-group">
                                                                                    <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} onBlur={(e) => handleChange(item.Cell2uuid, e)} />
                                                                                    <span className="input-group-text" id="basic-addon2">%</span>
                                                                                </div>
                                                                            );

                                                                        }
                                                                        else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'percentage') {
                                                                            return (
                                                                                item.Cell2Data + '%'
                                                                            );
                                                                        }
                                                                        else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'currency') {
                                                                            return (
                                                                                <>
                                                                                    {CurrencyFormatter({ amount: parseFloat(item.Cell2Data) })}
                                                                                </>
                                                                            );
                                                                        }

                                                                        else if (item.Cell2isEditable && item.Cell2EditStyle === 'currency') {
                                                                            return (
                                                                                <div className="input-group">
                                                                                    <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} onBlur={(e) => handleChange(item.Cell2uuid, e)} />
                                                                                    <span className="input-group-text" id="basic-addon2" dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                                                                </div>
                                                                            );
                                                                        } else if (item.Cell2isEditable && item.Cell2EditStyle === 'number') {
                                                                            return (
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} onBlur={(e) => handleChange(item.Cell2uuid, e)} />
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                item.Cell2Data
                                                                            );
                                                                        }
                                                                    })()}

                                                                </td>
                                                                <td className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>
                                                                    {(() => {
                                                                        if (item.Cell3isEditable && item.Cell3EditStyle === 'percentage') {
                                                                            return (
                                                                                <div className="input-group">
                                                                                    <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} onBlur={(e) => handleChange(item.Cell3uuid, e)} />
                                                                                    <span className="input-group-text" id="basic-addon2">%</span>
                                                                                </div>
                                                                            );

                                                                        }
                                                                        else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'percentage') {
                                                                            return (
                                                                                item.Cell3Data + '%'
                                                                            );
                                                                        }
                                                                        else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'currency') {
                                                                            return (
                                                                                <>
                                                                                    {CurrencyFormatter({ amount: parseFloat(item.Cell3Data) })}
                                                                                </>
                                                                            );
                                                                        }

                                                                        else if (item.Cell3isEditable && item.Cell3EditStyle === 'currency') {
                                                                            return (
                                                                                <div className="input-group">
                                                                                    <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} onBlur={(e) => handleChange(item.Cell3uuid, e)} />
                                                                                    <span className="input-group-text" id="basic-addon2" dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                                                                </div>
                                                                            );
                                                                        } else if (item.Cell3isEditable && item.Cell3EditStyle === 'number') {
                                                                            return (
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} onBlur={(e) => handleChange(item.Cell3uuid, e)} />
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                item.Cell3Data
                                                                            );
                                                                        }
                                                                    })()}
                                                                </td>
                                                                <td className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>

                                                                    {(() => {
                                                                        if (item.Cell4isEditable && item.Cell4EditStyle === 'percentage') {
                                                                            return (
                                                                                <div className="input-group">
                                                                                    <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} onBlur={(e) => handleChange(item.Cell4uuid, e)} />
                                                                                    <span className="input-group-text" id="basic-addon2">%</span>
                                                                                </div>
                                                                            );

                                                                        }
                                                                        else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'percentage') {
                                                                            return (
                                                                                item.Cell4Data + '%'
                                                                            );
                                                                        }
                                                                        else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'currency') {
                                                                            return (
                                                                                <>
                                                                                    {CurrencyFormatter({ amount: parseFloat(item.Cell4Data) })}
                                                                                </>
                                                                            );
                                                                        }

                                                                        else if (item.Cell4isEditable && item.Cell4EditStyle === 'currency') {
                                                                            return (
                                                                                <div className="input-group">
                                                                                    <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} onBlur={(e) => handleChange(item.Cell4uuid, e)} />
                                                                                    <span className="input-group-text" id="basic-addon2" dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                                                                </div>
                                                                            );
                                                                        } else if (item.Cell4isEditable && item.Cell4EditStyle === 'number') {
                                                                            return (
                                                                                <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} onBlur={(e) => handleChange(item.Cell4uuid, e)} />
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                item.Cell4Data
                                                                            );
                                                                        }
                                                                    })()}



                                                                </td>
                                                            </tr>
                                                        )
                                                        // }
                                                    }
                                                    )}




                                                </tbody>
                                                {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{items[items.length-1].Cell1}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },


            DownloadReportCardsSection: {

                render: ({ Heading, Description, Padding, logo, Lists, Settings, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                                <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>
                                    <div className="container position-relative">
                                        <div className="logo-wrap">
                                            <Link to="">
                                                <img src={resolveMediaUrl(logo)} alt="" />
                                            </Link>
                                        </div>
                                        <div className="section-heading mb-3 mb-md-4">
                                            <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                            <p className={Description.Font}>{Description.text}</p>
                                        </div>
                                        <div className="report-posts-wrapper">

                                            <div className="list-box-1 d-grid gap-4" style={{ gridTemplateColumns: `repeat(${Settings.ItemsPerRow}, 1fr)`, }}>
                                                {Lists.map((list, i) => (
                                                    <div className={`list-box-inner ${Settings.IconPosition === 'left' ? 'd-flex' : ''}`} key={i}>
                                                        {Settings.ShowIcon ? <div className="icon-wrap">
                                                            <img src={list.Image} alt="" />
                                                        </div> : ""}

                                                        <div className={`text-wrap flex-grow-1`}>
                                                            <h4 className={`${Settings.TitleFont} ${Settings.TitleFontWeight} mb-3`} style={{ color: Settings.TitleColor }}>{list.Title}</h4>
                                                            <p className={`${Settings.DescriptionFont} ${Settings.DescriptionFontWeight} mb-0`}>{list.Description}</p>
                                                            {Settings.ShowButton
                                                                ? <div className="button-wrap pt-3">
                                                                    <a className="link d-inline-flex text-primary fw-700 fs-14 align-items-center" href={list.ButtonLink}>
                                                                        <span>{list.ButtonText}</span> <Svg name="button-arrow" />
                                                                    </a>
                                                                </div>
                                                                :
                                                                ""}

                                                        </div>
                                                    </div>

                                                ))}


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </>
                    )

                },
            },

            DownloadReportThankYou: {

                render: ({ logo, Description, hide }) => {
                    // Render nothing if hide is true
                    if (hide) {
                        return null;
                    }

                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                                <div className="report-build-wrapper report-thankyou">
                                    <div className="logo-wrap">
                                        <img src={resolveMediaUrl(logo)} alt="" />
                                    </div>
                                    <div className="desclaimer">
                                        <p className={Description.Font}>{Description.text}</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            // Landing Page components

            TransparentSection: {

                render: ({ Padding, Style }) => {

                    return (
                        <>
                            <div className={`component-section ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: `url("${resolveMediaCssUrl(Style.Background)}")`, backgroundColor: `${Style.BackgroundColor}`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                {/* <div className='overlay'></div> */}
                                <div className={`${Style.Width} position-relative`}>
                                    <DropZone zone="section" />
                                </div>
                            </div>
                        </>
                    )

                },
            },

            GradientSection: {

                render: ({ Padding, Style }) => {

                    return (
                        <>
                            <div className={`component-section gradient-bg ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`}>
                                {/* <div className='overlay'></div> */}
                                <div className={`${Style.Width} position-relative`}>
                                    <DropZone zone="section" />
                                </div>
                            </div>
                        </>
                    )

                },
            },

            Columns: {

                render: ({ columns, distribution, vertical, gap, Padding, Style, Border }) => {

                    return (
                        <div
                            className={`d-grid section-column ${vertical}`}
                            style={{

                                backgroundImage: `url("${Style?.Background}")`,
                                backgroundColor: `${Style?.BackgroundColor}`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                borderStyle: Border?.BorderStyle,
                                borderColor: Border?.BorderColor,
                                borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                                borderRadius: `${Border?.BorderRadius}px`,

                                gridTemplateColumns:
                                    distribution === "manual"
                                        ? "repeat(12, 1fr)"
                                        : `repeat(${columns.length}, 1fr)`,
                                gridColumnGap: `${gap}px`
                            }}
                        >
                            {columns.map(({ span, backgroundColor }, idx) => (
                                <div
                                    key={idx}
                                    className="w-100"
                                    style={{
                                        display: "flex",
                                        backgroundColor: backgroundColor,
                                        flexDirection: "column",
                                        gridColumn:
                                            span && distribution === "manual"
                                                ? `span ${Math.max(Math.min(span, 12), 1)}`
                                                : "",
                                    }}
                                >
                                    <DropZone
                                        zone={`column-${idx}`}
                                    // disallow={["Section"]}
                                    />
                                </div>
                            ))}
                        </div>
                    )

                },

            },

            Wrapper: {

                render: ({ Padding, Style, Border }) => {

                    return (
                        <>
                            <div className={`component-wrapper`}
                                style={
                                    {
                                        backgroundImage: `url("${resolveMediaCssUrl(Style.Background)}")`,
                                        backgroundColor: `${Style.BackgroundColor}`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                                        borderStyle: Border.BorderStyle,
                                        borderColor: Border.BorderColor,
                                        borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                                        borderRadius: `${Border.BorderRadius}px`,
                                    }
                                }>
                                {/* <div className='overlay'></div> */}
                                <div className={`position-relative`}>
                                    <DropZone zone="wrapper" />
                                </div>
                            </div>
                        </>
                    )

                },
            },

            Spacing: {

                render: ({ Height }) => {

                    return (
                        <div style={{ height: `${Height}` }}></div>
                    )

                },
            },

            Heading: {

                render: ({ Text, Padding }) => {

                    return (
                        <>
                            {(() => {
                                if (Text.tag === 'h1') {
                                    return (
                                        <h1
                                            className={`section-title m-0 size-h1 ${Text.fontWeight} ${Text.titleFont}`}
                                            style={{
                                                color: `${Text.Color}`,
                                                textAlign: Text.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                            </div>
                                        </h1>
                                    );
                                }
                                else if (Text.tag === 'h2') {
                                    return (
                                        <h2
                                            className={`section-title m-0 size-h2 ${Text.fontWeight} ${Text.titleFont}`}
                                            style={{
                                                color: `${Text.Color}`,
                                                textAlign: Text.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                            </div>
                                        </h2>
                                    );
                                }
                                else if (Text.tag === 'h3') {
                                    return (
                                        <h3 className={`section-title m-0 size-h3 ${Text.fontWeight} ${Text.titleFont}`}
                                            style={{
                                                color: `${Text.Color}`,
                                                textAlign: Text.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                            </div>
                                        </h3>
                                    );
                                }
                                else if (Text.tag === 'h4') {
                                    return (
                                        <h4 className={`section-title m-0 size-h4 ${Text.fontWeight} ${Text.titleFont}`}
                                            style={{
                                                color: `${Text.Color}`,
                                                textAlign: Text.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                            </div></h4>
                                    );
                                }
                                else if (Text.tag === 'h5') {
                                    return (
                                        <h5 className={`section-title m-0 size-h5 ${Text.fontWeight} ${Text.titleFont}`}
                                            style={{
                                                color: `${Text.Color}`,
                                                textAlign: Text.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                            </div></h5>
                                    );
                                }
                                else if (Text.tag === 'h6') {
                                    return (
                                        <h6 className={`section-title m-0 size-h6 ${Text.fontWeight} ${Text.titleFont}`}
                                            style={{
                                                color: `${Text.Color}`,
                                                textAlign: Text.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                            </div></h6>
                                    );
                                }
                            })()}

                        </>
                    )

                },
            },

            Text: {

                render: ({ Text }) => {

                    return (
                        <>
                            <div
                                style={{
                                    color: `${Text.Color}`,
                                    textAlign: Text.Align
                                }}
                                className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`} dangerouslySetInnerHTML={{ __html: Text.text }}>
                            </div>
                        </>
                    )

                },
            },

            Image: {

                render: ({ Image, AspectRatio, fullWidth }) => {

                    return (
                        <>
                            <div className="image-wrapper">
                                <img src={resolveMediaUrl(Image)} alt="" className={`img-fluid object-cover ${fullWidth && `w-100`} `} style={{ aspectRatio: `${AspectRatio}` }} />
                            </div>
                        </>
                    )

                },
            },

            RedCards: {

                render: ({ Lists, Settings }) => {

                    return (
                        <>
                            <div className="roi-cards-section card-layout-1">
                                <div className="cards-wrapper">
                                    <div className="row justify-content-center">
                                        {Lists.map((list, i) => (
                                            <div className="col-lg-4 col-md-6 mb-3"
                                                key={i}>
                                                <input className="form-check-input d-none" type="radio" name={Settings.Card.UniqueID} id={`${Settings.Card.UniqueID}-${i}`} />
                                                <label className="card-outer" htmlFor={`${Settings.Card.UniqueID}-${i}`} style={{
                                                    borderStyle: Settings.Border.BorderStyle,
                                                    borderColor: Settings.Border.BorderColor,
                                                    borderWidth: `${Settings.Border.BorderWidth}px`,
                                                    borderRadius: `${Settings.Border.BorderRadius}px`,
                                                    backgroundColor: Settings.Card.BackgroundColor,
                                                    paddingTop: `${Settings.Card.Padding.top}px`,
                                                    paddingRight: `${Settings.Card.Padding.right}px`,
                                                    paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                                    paddingLeft: `${Settings.Card.Padding.left}px`,
                                                    textAlign: Settings.Text.Align
                                                }}>



                                                    <div className="card-inner">
                                                        <div className="text-wrapper">
                                                            <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>
                                                            <p className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>{list.Description}</p>

                                                        </div>
                                                        <div className="button-wrapper">
                                                            <button className='btn btn-action'>
                                                                <Svg name="roi-card-button" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            WhiteCards: {

                render: ({ Lists, Settings }) => {

                    return (
                        <>
                            <div className="roi-cards-section card-layout-2">
                                <div className="cards-wrapper">
                                    <div className="row justify-content-center">
                                        {Lists.map((list, i) => (
                                            <div className="col-lg-4 col-md-6 mb-3"
                                                key={i}>
                                                <input className="form-check-input d-none" type="radio" name={Settings.Card.UniqueID} id={`${Settings.Card.UniqueID}-${i}`} />
                                                <label className="card-outer" htmlFor={`${Settings.Card.UniqueID}-${i}`} style={{
                                                    borderStyle: Settings.Border.BorderStyle,
                                                    borderColor: Settings.Border.BorderColor,
                                                    borderWidth: `${Settings.Border.BorderWidth}px`,
                                                    borderRadius: `${Settings.Border.BorderRadius}px`,
                                                    backgroundColor: Settings.Card.BackgroundColor,
                                                    paddingTop: `${Settings.Card.Padding.top}px`,
                                                    paddingRight: `${Settings.Card.Padding.right}px`,
                                                    paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                                    paddingLeft: `${Settings.Card.Padding.left}px`,
                                                    textAlign: Settings.Text.Align
                                                }}>

                                                    <div className="card-inner">
                                                        {list.Image ? <div class="icon-wrapper">
                                                            <img src={list.Image} alt="" height={Settings.Card.IconSize} width={Settings.Card.IconSize} />
                                                        </div> : ""}
                                                        <div className="text-wrapper">
                                                            <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>
                                                            <p className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>{list.Description}</p>

                                                        </div>
                                                        <div className="button-wrapper">
                                                            <button className='btn btn-action'>
                                                                <Svg name="roi-card-button" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            PieChart: {

                render: ({ chartOption }) => (
                    <>
                        <div className="echart-wrapper">
                            <ReactEcharts
                                style={{
                                    height: '200px',
                                    width: '100%',
                                }}
                                option={chartOption} />
                        </div>
                    </>
                ),
            },

            eCharts: {

                render: ({ Chart, hide }) => {
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="echart-wrap" style={{ opacity: inputOpacity }}>

                                {(() => {
                                    if (Chart.chooseChart === "pie") {
                                        return <ReactEcharts style={chartStyle} option={PieChartOptions} />;
                                    } else if (Chart.chooseChart === "bar") {
                                        return <ReactEcharts style={chartStyle} option={BarChartOptions} />;
                                    }
                                })()}

                            </div>
                        </>
                    )
                },
            },

            ToggleSwitch: {

                render: ({ items, ID, hide, Margin, Style }) => {
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative d-flex align-items-center ${Style?.Alignment}`} style={
                                {
                                    opacity: inputOpacity,
                                    margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                                }}>

                                <div className={`roi-toggle-switch d-flex align-items-center`}
                                    style={
                                        {
                                            borderStyle: 'solid',
                                            borderColor: '#B6B7B8',
                                            borderWidth: `1px 1px 1px 1px`,
                                            borderRadius: `4px`
                                        }}>
                                    {items.map((item, i) => (

                                        <div className="form-check" key={i}>
                                            <input className="form-check-input" name={ID} type="radio" defaultValue id={`${ID}-${i}`} />
                                            <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                                {item.Option}
                                            </label>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </>
                    )

                },
            },

            Collapsible: {

                render: ({ ID }) => {
                    // Calculate opacity based on hide value
                    // const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="collapse-header collapsed" data-bs-toggle="collapse" href={`#${ID}`} role="button" aria-expanded="false" aria-controls={`${ID}`}>
                                <DropZone zone={`collapse-header`} />
                                <div className="drop-icon">
                                    <Svg name="collapsible-icon" />
                                </div>
                            </div>

                            <div className="collapse-body collapse" id={`${ID}`}>
                                <DropZone zone={`collapse-body`} />
                            </div>
                        </>
                    )

                },

            },



        },
    };



    const currencyChange = async (e) => {
        let currency_selected = e.target.value;
        let current_currency = 'USD';
        let current_symbol = '$';
        let exchange_rate = 1;
        let calculated_arr_global = [];
        let updatedRoiActionArr = JSON.parse(JSON.stringify(roiActionArr));

        const response = await fetch(`${apiUrl}/roi-currency/list`);
        const result = await response.json();
        const res = result.data;

        console.log("ccurrency_selected --exchange rate", currency_selected)

        Object.keys(res).map((key) => {
            if (res[key].currency_name == currency_selected) {
                current_currency = res[key].currency_name;
                exchange_rate = res[key].exchange_rate;
                current_symbol = res[key].symbol;
                console.log("current_currency", current_currency, exchange_rate);
            }
        })
        // let currency_rate = currencyRates[currency_selected];
        let changedCurrency__ = changedCurrency ? changedCurrency : defaultCurrency;
        console.log("current_currency --exchange rate", current_currency, exchange_rate, current_symbol, defaultCurrency, changedCurrency)
        if ((changedCurrency__ == 'USD' && changedCurrency__ != current_currency) || (defaultCurrency == 'USD' && changedCurrency__ == '' && current_currency != 'USD')) {
            // console.log("--exchange rate", defaultCurrency + ' ==USD && ' + changedCurrency__ + '=="" && ' + current_currency + '!=USD');
            // console.log("--exchange rate", changedCurrency__ + ' ==USD && ' + changedCurrency__ + '!=' + current_currency);
            await Object.keys(roiActionArr).map((key) => {
                console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, typeof roiActionArr[key].value)
                if (roiActionArr[key].value != 0 && key != '' && typeof roiActionArr[key].value == 'number' && roiActionArr[key].currency == '1') {
                    console.log("I am in condition 1 ")
                    updatedRoiActionArr = {
                        ...updatedRoiActionArr,
                        [key]: {
                            ...updatedRoiActionArr[key],
                            value: parseFloat(updatedRoiActionArr[key].value * exchange_rate)
                        }
                    };
                    setRoiActionArr(updatedRoiActionArr)
                    // console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, updatedRoiActionArr[key].value)
                    calculated_arr_global.push({ variable: key, value: parseFloat(roiActionArr[key].value * exchange_rate).toFixed(2) })
                }
                else if (roiActionArr[key].value != 0 && typeof roiActionArr[key].value == 'string' && key != '' && !isNaN(roiActionArr[key].value) && roiActionArr[key].value !== '' && roiActionArr[key].currency == '1') {
                    console.log("I am in condition 2 ")
                    updatedRoiActionArr = {
                        ...updatedRoiActionArr,
                        [key]: {
                            ...updatedRoiActionArr[key],
                            value: parseFloat(parseFloat(updatedRoiActionArr[key].value) * exchange_rate)
                        }
                    };
                    setRoiActionArr(updatedRoiActionArr)
                    // console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, updatedRoiActionArr[key].value)
                    calculated_arr_global.push({ variable: key, value: parseFloat(parseFloat(roiActionArr[key].value) * exchange_rate).toFixed(2) })
                }
            })

        }

        // console.log("--exchange rate", changedCurrency__ + '!=' + 'USD' + ' && ' + changedCurrency__ + ' != ' + current_currency + ' && ' + changedCurrency__ + '!=' + "''" + exchangeRate + '---' + exchange_rate);
        if (changedCurrency__ != 'USD' && changedCurrency__ != current_currency && changedCurrency__ != '') {
            // console.log("--exchange rate", changedCurrency__ + '!=' + 'USD' + ' && ' + changedCurrency__ + ' != ' + current_currency + ' && ' + changedCurrency__ + '!=' + "''" + exchangeRate + '---' + exchange_rate);
            await Object.keys(roiActionArr).map((key) => {
                if (roiActionArr[key].value != 0 && key != '' && typeof roiActionArr[key].value == 'number' && roiActionArr[key].currency == '1') {
                    console.log("I am in condition 3 ")
                    console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, exchangeRate, exchange_rate, (roiActionArr[key].value / exchangeRate) * exchange_rate)
                    updatedRoiActionArr = {
                        ...updatedRoiActionArr,
                        [key]: {
                            ...updatedRoiActionArr[key],
                            value: (updatedRoiActionArr[key].value / exchangeRate) * exchange_rate
                        }
                    };
                    setRoiActionArr(updatedRoiActionArr)
                    calculated_arr_global.push({ variable: key, value: parseFloat(parseFloat(roiActionArr[key].value / exchangeRate) * exchange_rate).toFixed(2) })

                } else if (roiActionArr[key].value != 0 && typeof roiActionArr[key].value == 'string' && key != '' && !isNaN(roiActionArr[key].value) && roiActionArr[key].value !== '' && roiActionArr[key].currency == '1') {
                    console.log("I am in condition 4 ")
                    console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, exchangeRate, exchange_rate, (roiActionArr[key].value / exchangeRate) * exchange_rate)
                    updatedRoiActionArr = {
                        ...updatedRoiActionArr,
                        [key]: {
                            ...updatedRoiActionArr[key],
                            value: parseFloat((parseFloat(updatedRoiActionArr[key].value) / exchangeRate) * exchange_rate)
                        }
                    };
                    setRoiActionArr(updatedRoiActionArr)
                    calculated_arr_global.push({ variable: key, value: parseFloat((parseFloat(roiActionArr[key].value) / exchangeRate) * exchange_rate).toFixed(2) })
                }
            })



        }
        setChangedCurrency(current_currency)
        setCurrencySymbol(current_symbol)
        setExchangeRate(exchange_rate)

        console.log("calculated_arr_global --exchange rate", calculated_arr_global)
        //now create global array and pass it to update all uuid
        await updateValueForRenderAllPages(calculated_arr_global);

    }

    const homeRedirect = () => {
        window.location.reload();
    };

    //for button or link
    const onButtonClick = useCallback(async (uuid) => {

        //console.log("button q",uuid);
        const updatedRoiActionArr = {
            ...roiActionArr,
            [uuid]: {
                ...roiActionArr[uuid],
                value: 1
            }
        };

        // Update the state with the new object
        setRoiActionArr(updatedRoiActionArr);
        console.log("roiActionArr--1", uuid)
        console.log("roiActionArr--1=22", roiActionArr[uuid])
        console.log("updatedRoiActionArr",updatedRoiActionArr);
        if (roiActionArr[uuid].actions == "JumpToPage") { //condition for jump to page
            jumpToPage(roiActionArr[uuid].action_id)
        } else if (roiActionArr[uuid].actions == "JumpToUrl") { // condition for jump to url
            let link = roiActionArr[uuid].link
            window.open(link, '_blank');
        } else if (roiActionArr[uuid].actions == "OpenPopup") { //condition for jump to page
            openPopup(roiActionArr[uuid].action_id)
        } else if (roiActionArr[uuid].actions == "JumpToReport") { //condition for jump to page
            jumpToReport()
        }

    }, [roiActionArr]);


    const jumpToReport = async () => {
        try {
            console.log("jumpToReport");

        } catch (error) {
            console.error('Error with GET request:', error);
        }
    }

    const jumpToPage = useCallback(async (id) => {
        try {
            console.log("jumpToPage", id , currentPageId)   
            let checkRequired = true;
            console.log("roiActionArr",roiActionArr)
            //logic to check if any field is in required check on full page on any button click
            await Object.keys(roiActionArr).forEach(async (element, index) => {
                if (roiActionArr[element].roi_page_id != undefined &&
                    roiActionArr[element].required == true &&
                    roiActionArr[element].value == '' &&
                    roiActionArr[element].roi_page_id == currentPageId
                ) {
                    let errorMessage = 'Please enter a valid value';
                    checkRequired = false;
                    await updateErrorRequiredByUuid(currentPageId, element, errorMessage);
                }
                // console.log(Object.keys(roiActionArr).length-1, index, checkRequired)
                if (Object.keys(roiActionArr).length - 1 == index && checkRequired) {
                    setCurrentPageId(id);
                }
            });
            // console.log("checkRequired", checkRequired)
            // if (checkRequired) {
            //     console.log("reset")
            //     setCurrentPageId(id);
            // }
        } catch (error) {
            console.error('Error with GET request:', error);
        }
    }, [roiActionArr, currentPageId]);

    const openPopup = async (id) => {
        try {
            //console.log("PageID-",(roipages[id]))
            //setRenderModalData(JSON.parse(roipages[id]));

            setCurrentPopupPageId(id);
            setPopupStatus(true);
            
        } catch (error) {
            console.error('Error with GET request:', error);
        }
    }

    const refreshParentPage = async () => {
        setCurrentPopupPageId('');
        setPopupStatus(false);

    }

    const evaluateCondition = (condition, element) => {
        console.log("evaluateCondition", condition)

        const value = condition['value'] ?? '';
        // console.log("value", value)
        const operator = condition['operator'] ?? '';
        // console.log("operator", operator)
        const value_type = condition['value_type'] ?? '';
        // console.log("value_type", value_type)
        const variable = condition['variable'] ?? '';
        // console.log("variable", variable)
        const variable_data_type = condition['variable_data_type'] ?? '';
        // console.log("variable_data_type", variable_data_type)
        // console.log("roiActionArr[variable].value", roiActionArr[variable].value)
        // console.log(typeof roiActionArr[variable]?.value + "==" + typeof value)
        // console.log(eval(roiActionArr[variable]?.value == value))
        let return__ = false;
        if (roiActionArr[variable]?.value != undefined) {
            switch (operator) {
                case '==':
                    return__ = eval(parseFloat(roiActionArr[variable]?.value) == value);
                    break;
                case '!=':
                    return__ = eval(parseFloat(roiActionArr[variable].value) != value);
                    break;
                case '>':
                    return__ = eval(parseFloat(roiActionArr[variable].value) > value);
                    break;
                case '<':
                    return__ = eval(parseFloat(roiActionArr[variable].value) < value);
                    break;
                case '>=':
                    //console.log('evaluateCondition Cond', roiActionArr[variable].value,value,typeof roiActionArr[variable].value);
                    return__ = eval(parseFloat(roiActionArr[variable].value) >= value);
                    break;
                case '<=':
                    return__ = eval(parseFloat(roiActionArr[variable].value) <= value);
                    break;
                case 'is empty':
                    return__ = isEmpty(roiActionArr[variable].value);
                    break;
                case 'is not empty':
                    return__ = !isEmpty(roiActionArr[variable].value);
                    break;
                case "is":
                    return__ = eval(roiActionArr[variable].value === value);
                    break;
                case "is not":
                    return__ = eval(roiActionArr[variable].value !== value);
                    break;
                case "contains":
                    return__ = (roiActionArr[variable].value).includes(value);
                    break;
                case "does not contain":
                    return__ = !(roiActionArr[variable].value).includes(value);
                    break;
                case "starts with":
                    return__ = (roiActionArr[variable].value).startsWith(value);
                    break;
                case "does not start with":
                    return__ = !(roiActionArr[variable].value).startsWith(value);
                    break;
                case "ends with":
                    return__ = (roiActionArr[variable].value).endsWith(value);
                    break;
                case "does not end with":
                    return__ = !(roiActionArr[variable].value).endsWith(value);
                    break;
                default:
                    return__ = false;
            }
            // if (element == 'cfe5d132-b6b0-4a28-a505-c23ea9f4de2b') {



        }
        console.log("return__", return__)
        return return__;
    };

    const isEmpty = (value) => {
        return (
            value === null ||                          // check for null
            value === undefined ||                     // check for undefined
            value === "" ||                            // check for empty string
            (Array.isArray(value) && value.length === 0) || // check for empty array
            (typeof value === 'object' && value !== null && Object.keys(value).length === 0)  // check for empty object
        );
    }


    const processLogic = async () => {

        let logics = allCondtionalLogicData;
        console.log("roiActionArr--2", roiActionArr);
        let roiActionArr__ = JSON.parse(JSON.stringify(roiActionArr));

        Object.keys(roiActionArr__).forEach(async (element) => {
            roiActionArr__ = {
                ...roiActionArr__,
                [element]: {
                    ...roiActionArr__[element],
                    count: 0
                }
            };
        });

        let is_changed = 2;
        let count = 0;
        let calculated_arr_global = [];
        await Object.keys(logics).forEach(async (element, index) => {
            //  console.log("element",element)
            await Object.keys(logics[element]).forEach(async (element1, index1) => {
                // console.log(element1);
                // console.log(logics[element][element1]);
                const { when, when_and_or_operator, then } = logics[element][element1];

                let conditionResult = when_and_or_operator === 'AND' ? true : false;

                for (const condition of when) {
                    const result = evaluateCondition(condition, element);
                    if (when_and_or_operator === 'AND') {
                        conditionResult = conditionResult && result;
                    } else {
                        conditionResult = conditionResult || result;
                    }
                }

                if (element == 'c0686b32-6e7b-4dde-a698-b9737c80a45a' || element == 'cfe5d132-b6b0-4a28-a505-c23ea9f4de2b') {
                    console.log("roiActionArr--2 ------------------------------------------")
                    console.log("roiActionArr--2", conditionResult)
                }
                //  console.log(logics[element][element1], conditionResult)
                if (conditionResult) {

                    let calculated_arr = [];
                    // then.forEach(action => executeAction(action));
                    await then.forEach(action => {
                        const { action: type, value, variable, variable_data_type, operator: action_type, value_type } = action;
                        //console.log("executeAction", type, value, variable, variable_data_type, action_type, value_type)
                        let val__;
                        switch (type) {
                            case 'calculate':
                                if (action_type === 'assign') {
                                    if (variable_data_type === 'number') {
                                        if (value_type == "static") {
                                            // console.log("assign static----n", value +"!= undefined &&"  + value +"!= null && "+value +"!= "+'""'+ " && "+value +"!= "+roiActionArr__[variable]?.['value'])
                                            if (value != undefined && value != null && value != "" && value != roiActionArr__[variable]?.['value']) {
                                                if (variable === '0bfa3ea6-a158-40fb-ac0e-195fdf4fd624') {
                                                    console.log("roiActionArr__ changed static--end", variable, value)
                                                }
                                                if (roiActionArr__[variable]?.['value'] != 0 && roiActionArr__[variable]?.['value'] != '' && roiActionArr__[variable]?.['value'] != null && roiActionArr__[variable]?.['value'] != undefined && "1" == roiActionArr__[variable]?.['currency']) {

                                                } else {
                                                    roiActionArr__ = {
                                                        ...roiActionArr__,
                                                        [variable]: {
                                                            ...roiActionArr__[variable],
                                                            value: value
                                                        }
                                                    };
                                                    calculated_arr.push({ variable: variable, value: parseFloat(value).toFixed(2) })
                                                }
                                            }
                                        } else if (value_type == "dynamic") {
                                            // console.log(roiActionArr__?.[value]?.value + "!=" + "undefined && " + roiActionArr__?.[value]?.value + "!= null && " + roiActionArr__?.[value]?.value + "!= " + `"" &&` + roiActionArr__?.[value]?.value + "!=" + roiActionArr__?.[variable]?.['value'] + "&& " + roiActionArr__?.[variable]?.['value'] + "!= undefined");
                                            if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && roiActionArr__?.[value]?.value != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                                                // console.log("assign dynamic----n", " I am here", roiActionArr__?.[value].value, roiActionArr__?.[variable]?.['value']);
                                                let val = roiActionArr__[value].value;
                                                //console.log("roiActionArr__ changed dynamic ", variable, val)
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: val
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }

                                        }
                                    }
                                    else {
                                        if (value_type == "static") {
                                            // console.log("assign static----n", value +"!= undefined &&"  + value +"!= null && "+value +"!= "+'""'+ " && "+value +"!= "+roiActionArr__[variable]?.['value'])
                                            if (value != undefined && value != null && value != "" && value != roiActionArr__[variable]?.['value']) {
                                                console.log("roiActionArr__ changed static--end - string", variable, value)
                                                if (roiActionArr__[variable]?.['value'] != 0 && roiActionArr__[variable]?.['value'] != '' && roiActionArr__[variable]?.['value'] != null && roiActionArr__[variable]?.['value'] != undefined && "1" == roiActionArr__[variable]?.['currency']) {

                                                } else {
                                                    roiActionArr__ = {
                                                        ...roiActionArr__,
                                                        [variable]: {
                                                            ...roiActionArr__[variable],
                                                            value: value
                                                        }
                                                    };
                                                    calculated_arr.push({ variable: variable, value: value })
                                                }
                                            }
                                        } else if (value_type == "dynamic") {
                                            // console.log(roiActionArr__?.[value]?.value + "!=" + "undefined && " + roiActionArr__?.[value]?.value + "!= null && " + roiActionArr__?.[value]?.value + "!= " + `"" &&` + roiActionArr__?.[value]?.value + "!=" + roiActionArr__?.[variable]?.['value'] + "&& " + roiActionArr__?.[variable]?.['value'] + "!= undefined");
                                            if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && roiActionArr__?.[value]?.value != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                                                // console.log("assign dynamic----n", " I am here", roiActionArr__?.[value].value, roiActionArr__?.[variable]?.['value']);
                                                let val = roiActionArr__[value].value;
                                                //console.log("roiActionArr__ changed dynamic - string", variable, val)
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: val
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: val })

                                            }

                                        }
                                    }
                                }

                                if (action_type === 'add') {
                                    if (variable_data_type === 'number') {
                                        if (value_type == "static") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) + parseFloat(value);
                                            if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                                                //console.log("add static----n", " I am here", value, roiActionArr__[variable]?.['value']);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }
                                        } else if (value_type == "dynamic") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) + parseFloat(roiActionArr__[value]?.value);
                                            if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                                                //console.log("add dynamic----n", " I am here", roiActionArr__?.[value]?.value, roiActionArr__?.[variable]?.['value']);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }

                                        }
                                    }
                                }

                                if (action_type === 'subtract') {
                                    if (variable_data_type === 'number') {
                                        if (value_type == "static") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) - parseFloat(value);
                                            if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                                                //console.log("subtract static----n", " I am here", value, roiActionArr__[variable]?.['value']);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }
                                        } else if (value_type == "dynamic") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) - parseFloat(roiActionArr__[value]?.value);
                                            if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                                                //console.log("subtract dynamic----n", " I am here", roiActionArr__?.[value]?.value, roiActionArr__?.[variable]?.['value']);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }


                                        }
                                    }
                                }

                                if (action_type === 'multiply') {
                                    if (variable_data_type === 'number') {
                                        if (value_type == "static") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) * parseFloat(value);
                                            if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                                                //console.log("multiply static----n", " I am here", parseFloat(value), parseFloat(roiActionArr__[variable]?.['value']), val);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }
                                        } else if (value_type == "dynamic") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) * parseFloat(roiActionArr__[value]?.value);
                                            if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                                                //console.log("multiply dynamic----n", " I am here", parseFloat(roiActionArr__?.[value]?.value), parseFloat(roiActionArr__?.[variable]?.['value']), val);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }

                                        }
                                    }
                                }

                                if (action_type === 'divide') {
                                    if (variable_data_type === 'number') {
                                        if (value_type == "static") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) / parseFloat(value);
                                            if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                                                //console.log("divide static----n", " I am here", parseFloat(value), parseFloat(roiActionArr__[variable]?.['value']), val);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }
                                        } else if (value_type == "dynamic") {
                                            let val = parseFloat(roiActionArr__[variable]?.value) / parseFloat(roiActionArr__[value]?.value);
                                            if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                                                //console.log("divide dynamic----n", " I am here", parseFloat(roiActionArr__?.[value]?.value), parseFloat(roiActionArr__?.[variable]?.['value']), val);
                                                roiActionArr__ = {
                                                    ...roiActionArr__,
                                                    [variable]: {
                                                        ...roiActionArr__[variable],
                                                        value: parseFloat(val)
                                                    }
                                                };
                                                calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(2) })
                                            }

                                        }
                                    }
                                }
                                break;
                            case 'show_blocks':
                            case 'hide_blocks':
                                console.log(`${type} these blocks: ${value}`);
                                break;
                            case 'disable_item':
                                console.log(`Disabling item: ${value}`);
                                break;
                            case 'jump_to_page':
                                console.log(`Jumping to page: ${value}`);
                                jumpToPage(value);
                                break;
                            default:
                                console.log('Action not recognized');
                        }

                        // if (val__ != undefined) {
                        // console.log("updateValueForRenderAllPages", variable, val__)
                        // updateValueForRenderAllPages(variable, val__);
                        // }
                    });

                    // console.log("roiActionArr calculated_arr top", element, calculated_arr)
                    //assigning all calculated values to roiActionArr
                    calculated_arr?.forEach((element, index) => {
                        // console.log("updateValueForRenderAllPages", element.variable, element.value)
                        if (element.value != undefined && element.value != null && element.value != "" && roiActionArr[element.variable]?.['value'] != roiActionArr__[element.variable]?.['value']) {
                            roiActionArr__ = {
                                ...roiActionArr__,
                                [element.variable]: {
                                    ...roiActionArr__[element.variable],
                                    // value: element.value,
                                    count: roiActionArr__[element.variable]?.count + 1
                                }
                            };

                            if (count < roiActionArr__[element.variable]?.count) {
                                //console.log("is_count", element.variable)
                                //console.log("is_count", roiActionArr__[element.variable])
                                count = roiActionArr__[element.variable]?.count;
                            }
                            is_changed = 1;
                            // console.log("is_changed", is_changed)
                            // setRoiFlag(true);
                            calculated_arr_global.push(element);
                        }

                        if (calculated_arr.length - 1 == index && is_changed == 2) {
                            is_changed = 3;
                        }
                    });

                    // if (calculated_arr.length > 0) {
                    //     calculated_arr_global.push(calculated_arr);
                    // }
                }
            });
        });


        //console.log("is_changed print roi action array  ", roiActionArr__)
        console.log("is_changed", is_changed)
        console.log("is_count", count)
        console.log("globalRoiArr", updateValues(globalRoiArr))
        console.log("roiActionArr print", calculated_arr_global)
        if (is_changed == 1 && count < 30) { //count to stop executing the logic after 4 times or 4 level depth
            //console.log("is_changed", is_changed)
            setGlobalRoiArr(globalRoiArr.concat(calculated_arr_global))
            setRoiActionArr(roiActionArr__);
        } else if (is_changed == 3 && globalRoiArr.length > 0) {
            await updateValueForRenderAllPages(updateValues(globalRoiArr));
            setGlobalRoiArr([]);
        }
    };

    const updateValues = (arr) => {
        const resultMap = {};

        arr.forEach(item => {
            resultMap[item.variable] = item.value;
        });

        return Object.keys(resultMap).map(key => ({
            variable: key,
            value: resultMap[key]
        }));
    };

    function debounce(func, delay) {
        let timer;
        return function (...args) {
            const context = this; // Capture context if needed (useful for non-arrow functions)
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }

    const updateErrorRequiredByUuid = useCallback(async (pageUuid, elementUuid, newValue) => {
        //console.log("updateValueByUuid", pageUuid, elementUuid, newValue)
        // Function to traverse and update the page data
        let level = 0;
        const traverseAndUpdate = async (data) => {
            // console.log("data", data)
            if (Array.isArray(data)) {
                const results = await Promise.all(data.map(item => traverseAndUpdate(item)));
                return results;
            } else if (data !== null && typeof data === 'object') {
                const newObj = {};
                for (const key of Object.keys(data)) {

                    const value = data[key];
                    if (key === 'uuid' && value === elementUuid && data.hasOwnProperty('value')) {
                        newObj[key] = value; // keep uuid the same
                        newObj['errorMessage'] = newValue; // update the value
                        newObj['value'] = ''; // update the value
                    } else if ((key !== 'errorMessage' && key !== 'value' && data['uuid'] == elementUuid)
                        || (data['uuid'] != elementUuid)) {
                        level++;
                        if (typeof value === 'object') {
                            newObj[key] = await traverseAndUpdate(value);
                        } else {
                            newObj[key] = value;
                        }
                    } else if (key === 'errorMessage' && newObj['errorMessage'] === undefined) {
                        newObj['errorMessage'] = data[key];
                    }


                }
                // console.log("newObj", newObj)
                return newObj;
            } else {
                return data;
            }
        };


        // Only update the specific page
        if (roipages.hasOwnProperty(pageUuid)) {
            // console.log("pageUuid", pageUuid)
            // console.log("roipages--121", roipages)
            // console.log("roipages--12", roipages[pageUuid])
            let pagedata = JSON.parse(JSON.stringify(roipages));
            // console.log("pagedata", pagedata)
            const updatedPage = await traverseAndUpdate(JSON.parse(pagedata[pageUuid]));
            console.log("updatedPage", updatedPage, pageUuid)
            setRoipages(prevData => {
                return {
                    ...prevData,
                    [pageUuid]: JSON.stringify(updatedPage) // Update only the specific page
                }
            });
            // console.log("roipages--1", roipages)
        }
    }, [roipages]);

    const updateValueByUuid = useCallback(async (pageUuid, elementUuid, newValue) => {
        //console.log("updateValueByUuid", pageUuid, elementUuid, newValue)
        // Function to traverse and update the page data
        let level = 0;
        const traverseAndUpdate = async (data) => {
            // console.log("data", data)
            if (Array.isArray(data)) {
                const results = await Promise.all(data.map(item => traverseAndUpdate(item)));
                return results;
            } else if (data !== null && typeof data === 'object') {
                const newObj = {};
                for (const key of Object.keys(data)) {


                    if (data.hasOwnProperty('Cell1Data')) { // Check if the object has the key 'Cell1Data' for table data
                        const value = data[key];
                        let check_digit = 0;
                        if (value == elementUuid) {
                            const regex = /(\d+)/;
                            const digit = key.match(regex);
                            newObj['Cell' + digit[0] + 'Data'] = newValue;
                            newObj['Cell' + digit[0] + 'uuid'] = value;
                            check_digit = digit[0];
                        } else if (value != elementUuid) {
                            if (check_digit != 0 && key == 'Cell' + check_digit + 'Data') {

                            } else {
                                newObj[key] = value;
                            }
                        }
                    } else {
                        const value = data[key];
                        if (key === 'uuid' && value === elementUuid && data.hasOwnProperty('value')) {
                            newObj[key] = value; // keep uuid the same
                            newObj['value'] = newValue; // update the value
                            newObj['errorMessage'] = '';
                        } else if ((key !== 'errorMessage' && key !== 'value' && data['uuid'] == elementUuid)
                            || (data['uuid'] != elementUuid)) {
                            level++;
                            if (typeof value === 'object') {
                                newObj[key] = await traverseAndUpdate(value);
                            } else {
                                newObj[key] = value;
                            }
                        } else if (key === 'value' && newObj['value'] === undefined) {
                            newObj['value'] = data[key];
                        }
                    }
                }
                // console.log("newObj", newObj)
                return newObj;
            } else {
                return data;
            }
        };


        // Only update the specific page
        if (roipages.hasOwnProperty(pageUuid)) {
            // console.log("pageUuid", pageUuid)
            // console.log("roipages--121", roipages)
            // console.log("roipages--12", roipages[pageUuid])
            let pagedata = JSON.parse(JSON.stringify(roipages));
            // console.log("pagedata", pagedata)
            const updatedPage = await traverseAndUpdate(JSON.parse(pagedata[pageUuid]));
            console.log("updatedPage", updatedPage, pageUuid)
            setRoipages(prevData => {
                return {
                    ...prevData,
                    [pageUuid]: JSON.stringify(updatedPage) // Update only the specific page
                }
            });
            // console.log("roipages--1", roipages)
        }
    }, [roipages]);


    const updateValueForRenderAllPages = useCallback(async (calculated_arr_global) => {
        //.log("I am in updateValueForRenderAllPages", calculated_arr_global)
        // let elementUuid = '', newValue = '';
        // Function to traverse and update the page data
        let level = 0;
        const traverseAndUpdate = async (data, calculated_arr_global, pageUuid) => {
            // console.log("data", data)
            if (Array.isArray(data)) {
                const results = await Promise.all(data.map(item => traverseAndUpdate(item, calculated_arr_global, pageUuid)));
                return results;
            } else if (data !== null && typeof data === 'object') {
                const newObj = {};
                for (const key of Object.keys(data)) {

                    if (data.hasOwnProperty('Cell1Data')) { // Check if the object has the key 'Cell1Data' for table data
                        const value = data[key];
                        let check__ = false;
                        let check_digit = 0;
                        await Object.keys(calculated_arr_global).forEach(async (element) => {

                            if (value == calculated_arr_global[element].variable) {

                                const regex = /(\d+)/;
                                const digit = key.match(regex);
                                newObj['Cell' + digit[0] + 'Data'] = calculated_arr_global[element].value;
                                newObj['Cell' + digit[0] + 'uuid'] = value;
                                check_digit = digit[0];
                                check__ = true;
                            }
                        });

                        if (check__ == false) {
                            // if (value != element.variable) {
                            if (check_digit != 0 && key == 'Cell' + check_digit + 'Data') {

                            } else {
                                newObj[key] = value;
                            }
                            // }
                        }
                    } else if (data.hasOwnProperty('Value1')) { // Check if the object has the key 'Cell1Data' for table data
                        const value = data[key];
                        let check__ = false;
                        let check_digit = 0;
                        await Object.keys(calculated_arr_global).forEach(async (element) => {

                            if (value == calculated_arr_global[element].variable) {

                                const regex = /(\d+)/;
                                const digit = key.match(regex);
                                newObj['Value' + digit[0]] = calculated_arr_global[element].value;
                                newObj['Value' + digit[0] + 'uuid'] = value;
                                check_digit = digit[0];
                                check__ = true;
                            }
                        });

                        if (check__ == false) {
                            // if (value != element.variable) {
                            if (check_digit != 0 && key == 'Value' + check_digit) {

                            } else {
                                newObj[key] = value;
                            }
                            // }
                        }
                    } else {
                        const value = data[key];
                        let check__ = false;
                        await Object.keys(calculated_arr_global).forEach(async (element) => {
                            if (key === 'uuid' && value === calculated_arr_global[element].variable && data.hasOwnProperty('value')) {
                                //console.log("new value", calculated_arr_global[element].value);
                                newObj[key] = value; // keep uuid the same
                                newObj['value'] = calculated_arr_global[element].value; // update the value
                                check__ = true;
                            }
                        });
                        if (check__ == false) {
                            if (key !== 'value') {
                                level++;
                                if (typeof value === 'object') {
                                    newObj[key] = await traverseAndUpdate(value, calculated_arr_global, [pageUuid]);
                                } else {
                                    newObj[key] = value;
                                }
                            } else if (key === 'value' && newObj['value'] === undefined) {
                                newObj['value'] = data[key];
                            }
                        }
                    }
                }
                // console.log("newObj", newObj)
                return newObj;
            } else {
                return data;
            }
        };


        // Only update the specific page
        let roipages__ = JSON.parse(JSON.stringify(roipages));
        await Object.keys(roipages__).forEach(async (pageUuid, index) => {
            let pagedata = JSON.parse(JSON.stringify(roipages__));
            console.log("ddd")
            //loop to update all updated element at once in a page
            // let updatedPage = JSON.parse(pagedata[pageUuid]);
            // Object.keys(calculated_arr_global).forEach(async (element) => {
            if (pageUuid == 'aefec6f0-05ef-11ef-8e01-1982dfb1577d') {
                console.log("updating all roi pages aefec6f0-05ef-11ef-8e01-1982dfb1577d--start", pagedata[pageUuid])
            }
            let updatedPage = await traverseAndUpdate(JSON.parse(pagedata[pageUuid]), calculated_arr_global, pageUuid);
            //console.log("updating all roi pages ", JSON.stringify(updatedPage))
            if (pageUuid == 'aefec6f0-05ef-11ef-8e01-1982dfb1577d') {
                console.log("updating all roi pages aefec6f0-05ef-11ef-8e01-1982dfb1577d", JSON.stringify(updatedPage))
            }

            // });

            // setRoipages(prevData => {
            //     return {
            //         ...prevData,
            //         [pageUuid]: JSON.stringify(updatedPage) // Update only the specific page
            //     }
            // });

            roipages__[pageUuid] = JSON.stringify(updatedPage);
            if (index == Object.keys(roipages__).length - 1) {
                console.log("I am in updateValueForRenderAllPages--end");
                setRoipages(roipages__);
            }

        });
    }, [roipages]);

    //for inputs type text
    const handleChange = useCallback(async (uuid, e, required = false) => {
        if (e.target.value == '' && required == true) {
            // toast.error('Please enter a valid value');
            let errorMessage = 'Please enter a valid value';
            await updateErrorRequiredByUuid(currentPageId, uuid, errorMessage);

            const updatedRoiActionArr = {
                ...roiActionArr,
                [uuid]: {
                    ...roiActionArr[uuid],
                    value: ''
                }
            };
            //console.log("roiActionArr--2", updatedRoiActionArr)
            setRoiActionArr(updatedRoiActionArr);
        } else {
            if (uuid !== '' && uuid !== undefined && uuid !== null && e !== '' && e !== undefined && e !== null) {


                // console.log('roipages[1123]', roipages[currentPageId])
                // console.log(roiActionArr);
                //console.log(uuid);
                // console.log(e.target.value);
                const updatedRoiActionArr = {
                    ...roiActionArr,
                    [uuid]: {
                        ...roiActionArr[uuid],
                        value: e.target.value
                    }
                };
                //console.log("roiActionArr--2", updatedRoiActionArr)
                setRoiActionArr(updatedRoiActionArr);
                if (popupStatus == false) {
                    await updateValueByUuid(currentPageId, uuid, e.target.value);
                }
                if (popupStatus == true) {
                    await updateValueByUuid(currentPopupPageId, uuid, e.target.value);
                }
                // Update the state with the new object

            }
        }
    }, [roiActionArr, currentPageId, updateValueByUuid]);

    //for checkbox
    const onCheckBoxClick = useCallback(async (uuid) => {
        let value = roiActionArr[uuid].value;
        if (value == '1') {
            const updatedRoiActionArr = {
                ...roiActionArr,
                [uuid]: {
                    ...roiActionArr[uuid],
                    value: '0'
                }
            };
            value = '0';
            setRoiActionArr(updatedRoiActionArr);
            await updateValueByUuid(currentPageId, uuid, value);


        } else {
            const updatedRoiActionArr = {
                ...roiActionArr,
                [uuid]: {
                    ...roiActionArr[uuid],
                    value: '1'
                }
            };
            value = '1';
            setRoiActionArr(updatedRoiActionArr);
            await updateValueByUuid(currentPageId, uuid, value);


        }


    }, [roiActionArr, currentPageId, updateValueByUuid]);

    const handleDropdownChange = useCallback(async (uuid, e) => {
        console.log("uuid", uuid, e.target.value)
        const changedArr = {
            ...changedDropdown,
            [uuid]: e.target.value

        };
        console.log("changedArr", changedArr)
        setChangedDropdown(changedArr);

        const updatedRoiActionArr = {
            ...roiActionArr,
            [uuid]: {
                ...roiActionArr[uuid],
                value: e.target.value
            }
        };
        console.log("roiActionArr--2", updatedRoiActionArr)
        setRoiActionArr(updatedRoiActionArr);
        await updateValueByUuid(currentPageId, uuid, e.target.value);
    }, [roiActionArr, currentPageId, updateValueByUuid]);

    useEffect(() => {
        //console.log("action triggered")
        //console.log("roiActionArr", roiActionArr)
        // let updatedRoiActionArr = {};
        // Object.keys(roiActionArr).forEach(async (element) => {
        //     updatedRoiActionArr = {
        //         ...roiActionArr,
        //         [element]: {
        //             ...roiActionArr[element],
        //             count: 0
        //         }
        //     };
        // });
        // setRoiActionArr(updatedRoiActionArr);
        setGlobalRoiArr([]);
        processLogic();
        // }, [roiActionArr]);
    }, [roipages]);

    useEffect(() => {
        //console.log("exchange action triggered")
        // console.log("exchange roiActionArr", roiActionArr)
        if (globalRoiArr.length > 0) {
            console.log("globalRoiArr action triggered")
            processLogic();
        }
    }, [globalRoiArr]);

    useEffect(() => {
        console.log("pages triggered", currentPageId);
        // console.log('roipages[all]', roipages['54cfe3bb-6400-4f1c-a6eb-1370fd41e3fd'])
        if (currentPopupPageId !== '' && roipages[currentPopupPageId] !== undefined && popupStatus == true) {
            console.log("Page_test");
            setRenderModalData(JSON.parse(roipages[currentPopupPageId]));
        }
        if (currentPageId !== '' && roipages[currentPageId] !== undefined) {
            setRenderData(JSON.parse(roipages[currentPageId]));
            // console.log('roipages[currentPageId]', roipages[currentPageId])
        }
    }, [roipages, currentPageId, currentPopupPageId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiUrl}/roi/getRoiDetail/${roiId}`);
                const data = await response.json();
                const res = data.data;
                // console.log("res", res);
                setIsIdPresent(res.is_active);
                // console.log("res.is_active", res.is_active);
                setLanguage(res.default_language);
                // console.log("res.default_language", res.default_language);
                setDefaultCurrency(JSON.parse(res.primary_currency)[0]);

                // setChangedCurrency(JSON.parse(res.primary_currency)[0])
                // console.log("res.primary_currency", JSON.parse(res.primary_currency)[0]);
                setCurrency(JSON.parse(res.additional_currency));
                // console.log("res.additional_currency", JSON.parse(res.additional_currency));
                // getting first strucuture api call 

                const response1 = await fetch(`${apiUrl}/roi-currency/list`);
                const result1 = await response1.json();
                const res1 = result1.data;

                Object.keys(res1).map((key) => {
                    if (res1[key].currency_name == JSON.parse(res.primary_currency)[0]) {
                        setCurrencySymbol(res1[key].symbol)
                        setLocale('en-US')
                        console.log('exchange_rate---3', res1[key].exchange_rate)
                        setExchangeRate(res1[key].exchange_rate);
                    }
                })


                try {
                    const responseStructure = await fetch(`${apiUrl}/roi-pages/detail/${roiId}`);
                    const dataStructure = await responseStructure.json();
                    setCurrentPageId(dataStructure.result?.[0]?.roi_page_id);
                    const parsedRenderData = JSON.parse(dataStructure.result?.[0]?.structure);
                    let roi_content = {};
                    let roi_global_arr = {};
                    let data = dataStructure.result;
                    console.log('data', data);
                    for (let i = 0; i < data.length; i++) {
                        roi_content[data[i].roi_page_id] = data[i].structure;
                        // console.log('data', data[i].structure);
                        let data__ = JSON.parse(data[i].structure)['content'];
                        // console.log(JSON.stringify(data__))
                        Object.keys(data__).forEach((element, index) => {

                            if (data__[element]?.type == 'InputTextField' ||
                                data__[element]?.type == 'InputNumberField' ||
                                data__[element]?.type == 'Button'
                            ) {

                                Object.keys(data__[element]?.props).forEach((element2, index2) => {
                                    if (data__[element]?.props?.uuid != undefined) {

                                        roi_global_arr[data__[element]?.props?.uuid] = {};
                                        roi_global_arr[data__[element]?.props?.uuid]['count'] = 0;
                                        roi_global_arr[data__[element]?.props?.uuid]['actions'] = data__[element]?.props?.buttonAction ?? '';
                                        roi_global_arr[data__[element]?.props?.uuid]['action_id'] = data__[element]?.props?.PageList ?? '';
                                        roi_global_arr[data__[element]?.props?.uuid]['link'] = data__[element]?.props?.buttonLink ?? '';
                                        roi_global_arr[data__[element]?.props?.uuid]['value'] = data__[element]?.props?.value ?? '';
                                        roi_global_arr[data__[element]?.props?.uuid]['default_value'] = data__[element]?.props?.default_value ?? '';

                                    }
                                });

                            } else {

                                // console.log('props',typeof (data__[element]?.props));
                                Object.keys(data__[element]?.props).forEach((element2, index2) => {
                                    if (data__[element]?.props[element2].uuid != undefined) {

                                        if (element2 !== 'image' &&
                                            element2 !== 'logo' &&
                                            element2 !== 'items' &&
                                            element2 !== 'id' &&
                                            element2 !== 'Padding' &&
                                            element2 !== 'Style') {
                                            //console.log(element2);
                                            //console.log(data__[element]?.props[element2].uuid);
                                            roi_global_arr[data__[element]?.props[element2].uuid] = {};
                                            roi_global_arr[data__[element]?.props[element2].uuid]['count'] = 0;
                                            roi_global_arr[data__[element]?.props[element2].uuid]['actions'] = data__[element]?.props[element2].buttonAction ?? '';
                                            roi_global_arr[data__[element]?.props[element2].uuid]['action_id'] = data__[element]?.props[element2].PageList ?? '';
                                            roi_global_arr[data__[element]?.props[element2].uuid]['link'] = data__[element]?.props[element2].buttonLink ?? '';
                                            roi_global_arr[data__[element]?.props[element2].uuid]['value'] = data__[element]?.props?.[element2]?.value ?? '';
                                            roi_global_arr[data__[element]?.props[element2].uuid]['default_value'] = data__[element]?.props[element2].default_value ?? '';


                                        }
                                    }
                                });
                            }
                        });

                        let data_zones__ = JSON.parse(data[i].structure)['zones'];
                        Object.keys(data_zones__).forEach((element, index) => {

                            Object.keys(data_zones__[element]).forEach((element__, index__) => {
                                let data_element__ = data_zones__[element][element__];
                                // console.log("data_element__", data_element__);
                                // console.log("data_element__", data_element__.props);
                                if (data_element__?.props.uuid != undefined) {
                                    if (data_element__?.type === 'InputTextField' ||
                                        data_element__?.type === 'InputNumberField' ||
                                        data_element__?.type === 'Dropdown' ||
                                        data_element__?.type === 'Button') {

                                        roi_global_arr[data_element__?.props.uuid] = {};
                                        roi_global_arr[data_element__?.props.uuid]['currency'] = data_element__?.props.prefix == 'currency' || data_element__?.props.prefix == 'Currency' || data_element__?.props.Prefix == 'Currency' || data_element__?.props.Prefix == 'currency' ? '1' : '0';
                                        roi_global_arr[data_element__?.props.uuid]['count'] = 0;
                                        roi_global_arr[data_element__?.props.uuid]['required'] = data_element__?.props.required ?? false;
                                        roi_global_arr[data_element__?.props.uuid]['type'] = data_element__?.type ?? '';
                                        roi_global_arr[data_element__?.props.uuid]['actions'] = data_element__?.props.buttonAction ?? '';
                                        roi_global_arr[data_element__?.props.uuid]['action_id'] = data_element__?.props.buttonValue ?? '';
                                        roi_global_arr[data_element__?.props.uuid]['link'] = data_element__?.props.buttonLink ?? '';
                                        roi_global_arr[data_element__?.props.uuid]['value'] = data_element__?.props?.value ?? '';
                                        roi_global_arr[data_element__?.props.uuid]['default_value'] = data_element__?.props.default_value ?? '';
                                        roi_global_arr[data_element__?.props.uuid]['roi_page_id'] = data[i].roi_page_id;


                                    }

                                    if (data_element__?.type === 'Checkbox') {
                                        Object.keys(data_element__?.props?.items).forEach((element, index) => {
                                            if (data_element__?.props?.items[element]?.uuid != undefined) {

                                                roi_global_arr[data_element__?.props?.items[element]?.uuid] = {};
                                                roi_global_arr[data_element__?.props?.items[element]?.uuid]['currency'] = data_element__?.props?.items[element]?.prefix == 'currency' || data_element__?.props?.items[element]?.prefix == 'Currency' || data_element__?.props?.items[element]?.Prefix == 'currency' || data_element__?.props?.items[element]?.Prefix == 'Currency' ? '1' : '0';
                                                roi_global_arr[data_element__?.props?.items[element]?.uuid]['count'] = 0;
                                                roi_global_arr[data_element__?.props?.items[element]?.uuid]['actions'] = data_element__?.props?.items[element]?.buttonAction ?? '';
                                                roi_global_arr[data_element__?.props?.items[element]?.uuid]['action_id'] = data_element__?.props?.items[element]?.buttonValue ?? '';
                                                roi_global_arr[data_element__?.props?.items[element]?.uuid]['link'] = data_element__?.props?.items[element]?.buttonLink ?? '';
                                                roi_global_arr[data_element__?.props?.items[element]?.uuid]['value'] = data_element__?.props?.items[element]?.value ?? '';
                                                roi_global_arr[data_element__?.props?.items[element]?.uuid]['default_value'] = data_element__?.props?.items[element]?.default_value ?? '';



                                            }
                                        });
                                    }

                                }
                                if (data_element__?.props?.uuid == undefined && data_element__?.props?.items != undefined) {
                                    Object.keys(data_element__?.props?.items).forEach((element, index) => {
                                        // console.log("data_element__?.props?.items[element]", data_element__?.props?.items[element]);
                                        if (data_element__?.props?.items[element]?.uuid != undefined) { //this will also work in case of button in card section

                                            roi_global_arr[data_element__?.props?.items[element]?.uuid] = {};
                                            roi_global_arr[data_element__?.props?.items[element]?.uuid]['currency'] = data_element__?.props?.items[element]?.prefix == 'currency' || data_element__?.props?.items[element]?.prefix == 'Currency' ? '1' : '0';
                                            roi_global_arr[data_element__?.props?.items[element]?.uuid]['count'] = 0;
                                            roi_global_arr[data_element__?.props?.items[element]?.uuid]['actions'] = data_element__?.props?.items[element]?.buttonAction ?? '';
                                            roi_global_arr[data_element__?.props?.items[element]?.uuid]['action_id'] = data_element__?.props?.items[element]?.buttonValue ?? '';
                                            roi_global_arr[data_element__?.props?.items[element]?.uuid]['link'] = data_element__?.props?.items[element]?.buttonLink ?? '';
                                            roi_global_arr[data_element__?.props?.items[element]?.uuid]['value'] = data_element__?.props?.items[element]?.value ?? '';
                                            roi_global_arr[data_element__?.props?.items[element]?.uuid]['default_value'] = data_element__?.props?.items[element]?.default_value ?? '';



                                        }

                                        if (data_element__?.props?.items[element]?.uuid == undefined &&
                                            (data_element__?.type === 'DownloadReportTable' || data_element__?.type === 'ReportTable')
                                        ) {
                                            // console.log("element", element)
                                            Object.keys(data_element__?.props?.items[element]).forEach((element_, index_) => {
                                                // console.log("data_element__?.props?.items[element]?.items[element_]", data_element__?.props?.items[element]?.items[element_]);

                                                let cols_count = data_element__?.props?.Table.Columns;
                                                for (let i = 1; i <= cols_count; i++) {
                                                    if (data_element__?.props?.items[element]?.['Cell' + i + 'uuid'] != undefined) {

                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']] = {};
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']]['currency'] = (data_element__?.props?.items[element]?.['Cell' + i + 'EditStyle']) == 'Currency' || (data_element__?.props?.items[element]?.['Cell' + i + 'EditStyle']) == 'currency' ? '1' : '0';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']]['count'] = 0;
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']]['actions'] = data_element__?.props?.items[element]?.['Cell' + i + 'Action'] ?? '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']]['action_id'] = data_element__?.props?.items[element]?.['Cell' + i + 'ActionId'] ?? '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']]['link'] = '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']]['value'] = data_element__?.props?.items[element]?.['Cell' + i + 'Data'] ?? '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Cell' + i + 'uuid']]['default_value'] = data_element__?.props?.items[element]?.['Cell' + i + 'Data'] ?? '';



                                                    }
                                                }

                                            });
                                        }

                                        if (data_element__?.props?.items[element]?.Value1 != undefined && data_element__?.type === 'CardSection') {
                                            Object.keys(data_element__?.props?.items[element]).forEach((element_, index_) => {
                                                for (let i = 1; i <= 4; i++) {
                                                    if (data_element__?.props?.items[element]?.['Value' + i + 'uuid'] != undefined) {
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']] = {};
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']]['currency'] = '1';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']]['count'] = 0;
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']]['actions'] = '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']]['action_id'] = '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']]['link'] = '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']]['value'] = data_element__?.props?.items[element]?.['Value' + i] ?? '';
                                                        roi_global_arr[data_element__?.props?.items[element]?.['Value' + i + 'uuid']]['default_value'] = '';

                                                    }
                                                }
                                            });
                                        }
                                    });

                                }


                                if (data_element__?.props?.uuid == undefined && data_element__?.props?.items == undefined) {
                                    if (data_element__?.type === 'ResultCard') {
                                        Object.keys(data_element__?.props).forEach((element, index) => {
                                            if (data_element__?.props?.[element]?.uuid != undefined) {

                                                roi_global_arr[data_element__?.props?.[element]?.uuid] = {};
                                                roi_global_arr[data_element__?.props?.[element]?.uuid]['currency'] = '1';
                                                roi_global_arr[data_element__?.props?.[element]?.uuid]['count'] = 0;
                                                roi_global_arr[data_element__?.props?.[element]?.uuid]['actions'] = data_element__?.props?.[element]?.buttonAction ?? '';
                                                roi_global_arr[data_element__?.props?.[element]?.uuid]['action_id'] = data_element__?.props?.[element]?.buttonValue ?? '';
                                                roi_global_arr[data_element__?.props?.[element]?.uuid]['link'] = data_element__?.props?.[element]?.buttonLink ?? '';
                                                roi_global_arr[data_element__?.props?.[element]?.uuid]['value'] = data_element__?.props?.[element]?.value ?? '';
                                                roi_global_arr[data_element__?.props?.[element]?.uuid]['default_value'] = data_element__?.props?.[element]?.default_value ?? '';



                                            }
                                        });
                                    }
                                }

                                if (data_element__?.type === 'ChartCard') {
                                    let props = data_element__?.props;
                                    Object.keys(props).forEach((element, index) => {
                                        if (props[element]?.uuid != undefined && (props[element]?.chooseChart == 'pie' || props[element]?.chooseChart == 'bar')) {
                                            for (let i = 0; i < props[element]?.items?.length; i++) {
                                                //console.log("chart element uuid", props[element]?.items[i].uuid);
                                                roi_global_arr[props[element]?.items[i].uuid] = {};
                                                roi_global_arr[props[element]?.items[i].uuid]['currency'] = '1';
                                                roi_global_arr[props[element]?.items[i].uuid]['count'] = 0;
                                                roi_global_arr[props[element]?.items[i].uuid]['actions'] = props[element]?.items[i].buttonAction ?? '';
                                                roi_global_arr[props[element]?.items[i].uuid]['action_id'] = props[element]?.items[i].buttonValue ?? '';
                                                roi_global_arr[props[element]?.items[i].uuid]['link'] = props[element]?.items[i].buttonLink ?? '';
                                                roi_global_arr[props[element]?.items[i].uuid]['value'] = props[element]?.items[i].Data ?? '';
                                                roi_global_arr[props[element]?.items[i].uuid]['default_value'] = props[element]?.items[i].default_value ?? '';

                                            }
                                        }
                                    });

                                }

                            });

                        });
                    }
                    //console.log("roi_global_arr", roi_global_arr)
                    setRoipages(roi_content)


                    const responseCustomVariables = await fetch(`${apiUrl}/roi-custom-variables/list/${roiId}`);
                    const dataCustomVariables = await responseCustomVariables.json();
                    if (dataCustomVariables.result == 'success') {
                        let customVariablesArray = dataCustomVariables.data;
                        for (let i = 0; i < customVariablesArray.length; i++) {
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id] = {};
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id]['currency'] = (customVariablesArray[i].roi_custom_variable_type == 'currency' ? '1' : '0');
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id]['count'] = 0;
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id]['actions'] = '';
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id]['action_id'] = '';
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id]['link'] = '';
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id]['value'] = customVariablesArray[i].roi_custom_variable_value;
                            roi_global_arr[customVariablesArray[i].roi_custom_variable_id]['default_value'] = '';

                        }
                    }

                    console.log("roi_global_arr---1", roi_global_arr);
                    setRoiActionArr(roi_global_arr)
                    //console.log("roipages", roipages);
                    // dataStructure.result.forEach(() => )
                    setRenderData(parsedRenderData);

                } catch (error) {
                    console.log(error);
                }

                // getting all condtional logic api call
                try {
                    const conditionalLogics_response = await fetch(`${apiUrl}/roi-calculated-fields/list/${roiId}`);
                    const json_conditionalLogics_response = await conditionalLogics_response.json();
                    // console.log("json_conditionalLogics_response", json_conditionalLogics_response);

                    if (json_conditionalLogics_response.result == 'success') {
                        let data = json_conditionalLogics_response.data;

                        const roiCalculationLogic = {};
                        let count = 0;
                        Object.keys(data).forEach((element, index) => {
                            //  console.log("element", data[element].roi_calculated_field_id  )
                            //  && (data[element].roi_logic_name).substring(0, 2) == 'LC'
                            if (data[element].roi_calculation_logic != undefined && data[element].roi_calculation_logic != null) {
                                // console.log("element", data[element].roi_calculated_field_id  )
                                const data__ = JSON.parse(data[element].roi_calculation_logic);
                                // console.log(data__);
                                // console.log(data__['when'].length)
                                if (data__['when'].length == 1) {
                                    data__['when_and_or_operator'] = "";
                                }
                                if (data__['when'].length > 1 && data__['when_and_or_operator'] == undefined || data__['when_and_or_operator'] == null) {
                                    data__['when_and_or_operator'] = "AND";
                                }
                                // for (let i = 0; i < data__['when'].length; i++) {
                                if (roiCalculationLogic[data[element].roi_calculated_field_id] === undefined) {
                                    // roiCalculationLogic[count] = [];
                                    roiCalculationLogic[data[element].roi_calculated_field_id] = [];
                                }
                                // if (data__['when'][0]['variable'] == '61d8605a-bd76-4ec6-afe2-de519bbc6dd9') {
                                //     console.log("data__['when'][0]", JSON.stringify(data__));
                                // }
                                data__['logic_name'] = data[element].roi_logic_name;
                                // roiCalculationLogic[count].push(data__);

                                roiCalculationLogic[data[element].roi_calculated_field_id].push(data__);
                                // count++;
                                // }
                            }

                        })
                        console.log("json_conditionalLogics_response", roiCalculationLogic);
                        setAllConditionalLogicData(roiCalculationLogic);
                    }






                } catch (error) {
                    console.log(error);
                }

                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoading(false);
            }
        };
        fetchData();
    }, [apiUrl, roiId]);


    // Debounce function with useCallback
    const debouncedOnChange = useMemo(() => debounce(handleChange, 1000), [handleChange]);


    // console.log("ree", renderData);

    if (isLoading) {
        return <div>Loading...</div>;
    }


    const renderDataBlock = () => {
        return (
            <>

                <Render
                    config={config}
                    data={renderData}
                />

                <div className="modal fade logo-prompt" id="logoPrompt" tabIndex={-1} aria-labelledby="logoPromptLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="heading">
                                    <h3>Return to home page?</h3>
                                    <p>You will have to complete the steps again.</p>
                                </div>

                                <div className="modal-buttons d-flex justify-content-end">
                                    <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">Close</button>
                                    <button type="button" className="btn btn-primary ms-3" onClick={homeRedirect}>Confirm</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }


    const renderModalDataBlock = () => {
        return (
            <Render
                config={config}
                data={renderModalData}
            />
        );
    }


    return (
        <>

            <ToastContainer />
            {renderData !== null && allCondtionalLogicData !== null ? (
                renderDataBlock()
            ) : (
                <div>Loading...</div>
            )}

            <div className="modal fade modal-report" id="reportModal" tabIndex={-1} aria-labelledby="reportModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        {renderModalData !== null && allCondtionalLogicData !== null ? (
                            renderModalDataBlock()
                        ) : (
                            <div>Loading...</div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );



};

export default ROIPage;
